import {
  ActionIcon,
  Alert,
  Anchor,
  Avatar,
  Badge,
  Box,
  Breadcrumbs,
  Button,
  Col,
  Container,
  Divider,
  Flex,
  Grid,
  Group,
  Modal,
  NumberInput,
  Select,
  Table,
  Text,
  TextInput,
  Tooltip,
  Card,
  Stack,
  Loader,
} from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { getHotkeyHandler, useForceUpdate, useMediaQuery } from "@mantine/hooks";
import {
  IconAlertCircle,
  IconClearAll,
  IconDiscount2,
  IconFile,
  IconFileInvoice,
  IconId,
  IconPrinter,
  IconSearch,
  IconSquareMinus,
  IconSquareRoundedMinus,
  IconTag,
  IconX,
  IconEdit,
  IconCheck,
} from "@tabler/icons";
import AddPaymentReceipt from "components/AddPaymentReceipt";
import CouponsModal from "components/CouponsModal";
import CustomerSelection from "components/CustomerSelection";
import printTemplate from "components/InvoicePrintComponent";
import PaymentReceiptModal from "components/PaymentReceiptModal";
import produce, { current } from "immer";
import moment from "moment";
import { coupons_api } from "pages/master/coupons/coupons.service";
import React, { forwardRef, useCallback, useEffect, useRef, useState } from "react";
import { useMutation, useQuery } from "react-query";
import { useLocation, useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";


import { constructInvoiceItem, getModifiedList } from "./InvoiceHelperFunctions";
import { invoice_api } from "./invoice.service";
import { showErrorToast, showSuccessToast } from "../../../utilities/Toast";
import { api_addPaymentReceipt } from "../payment-receipt/paymentReceipt.service";
import { getCounterId, isCounterAdmin } from "pages/Auth/permissionGuard";

export default function InvoiceMaster() {
  const batchTable = React.useRef("");
  const forceUpdate = useForceUpdate();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  let isMobileScreen = useMediaQuery("(max-width: 768px)");
  const location = useLocation();
  const counterId = getCounterId();

  // STARTS : States
  const [editFormVisible, setEditFormVisible] = useState(false);
  const [productSelectionModal, setProductSelectionModal] = useState(false);
  const [selectValue, setSelectValue] = useState("");
  const [productsList, setProductsList] = useState([]);
  const [productsSearchList, setProductsSearchList] = useState([]);
  const [isEditing, setIsEditing] = useState(false);

  const [deletedItems, setDeletedItems] = useState([]);

  // const [selectedBatchProductCode, setSelectedBatchProductCode] = useState(null);
  const [modalBatches, setModalBatches] = useState([]);
  const [currentBatch, setCurrentBatch] = useState({});
  // ENDS : States

  // Invoice states
  const [invoiceItemsList, setInvoiceItemsList] = useState([]);
  const [batches, setBatches] = useState([]);
  const [netDiscount, setNetDiscount] = useState(null);
  const [customerId, setCustomerId] = useState(null);
  const [invoiceTotal, setInvoiceTotal] = useState(null);
  const [payAndPrintBill, setPayAndPrintBill] = useState(false)
  const [activeShortcut, setActiveShortcut] = useState(null);
  // values: "coupon" | "discount" | null
  // Ends : Invoice states

  const [focusSearch, setfocusSearch] = useState(location.pathname.includes("edit"));

  // STARTS : States

  const [discFocus, setDiscFocus] = useState(false);
  const [focus, setFocus] = useState(false);
  const [paymentReceiptFormVisible, setPaymentReceiptFormVisible] = useState(false);
  const [invoicesData, setInvoicesData] = useState([]);
  const [invoicesId, setInvoicesId] = useState(null);
  const [mobileNumberErrorMessage, setMobileNumberErrorMessage] = useState("");
  const [packingCharge, setPackingCharge] = useState(0);
  const [loading, setLoading] = useState(false);

  const [couponsModalOpened, setCouponsModalOpened] = useState(false);
  const [couponCode, setCouponCode] = useState(null);
  const [coupons, setCoupons] = useState([]);
  const [couponApplied, setCouponApplied] = useState({});
  const [customers, setCustomers] = useState([]);
  const [customerSelected, setCustomerSelected] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [debouncedSearchValue, setDebouncedSearchValue] = useState("");

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchValue(searchValue);
    }, 500);
    return () => clearTimeout(handler);
  }, [searchValue]);
  const [lockFocus, setLockFocus] = useState(false);
  const [isInvoiceEditMode, setIsInvoiceEditMode] = useState(false);
  const [isInitialPopulated, setIsInitialPopulated] = useState(false);
  const [pendingStockReturns, setPendingStockReturns] = useState([]);


  // ENDS : States
  const [selectedRow, setSelectedRow] = useState(null);
  const [isListFocused, setIsListFocused] = useState(false);
  //
  const customerInputRef = useRef(null);
  const [customerSearch, setCustomerSearch] = useState("");
  const [paymentReceiptData, setPaymentReceiptData] = useState({});
  const [isEditInvoiceMode, setIsEditInvoiceMode] = useState(false);
  const [isF6Mode, setIsF6Mode] = useState(false);
  const [lastSelectedProductUnit, setLastSelectedProductUnit] = useState(null);

  // Add these with your other useState declarations
  const [referralCoupons, setReferralCoupons] = useState([]);
  const [selectedReferralCoupon, setSelectedReferralCoupon] = useState(null);
  const [showReferralCouponModal, setShowReferralCouponModal] = useState(false);
  const [referralCouponCode, setReferralCouponCode] = useState("");
  const [referralCouponApplied, setReferralCouponApplied] = useState(false);
  const [referralCouponError, setReferralCouponError] = useState("");

  // Exchange Flow state variables
  const [exchangeRefundCredit, setExchangeRefundCredit] = useState(() => {
    return parseFloat(sessionStorage.getItem("exchangeRefundCredit")) || 0;
  });
  const [originalInvoiceNo, setOriginalInvoiceNo] = useState(() => {
    return sessionStorage.getItem("originalInvoiceNo") || "";
  });
  const [originalInvoiceId, setOriginalInvoiceId] = useState(() => {
    return sessionStorage.getItem("originalInvoiceId") || null;
  });

  useEffect(() => {
    if (location.state?.isExchangeFlow) {
      const state = location.state;
      const refundCredit = state.totalRefundCredit || 0;
      const invNo = state.originalInvoiceNo || "";
      const invId = state.originalInvoiceId || null;
      const customer = state.customer;
      const items = state.exchangeItems || [];

      setExchangeRefundCredit(refundCredit);
      setOriginalInvoiceNo(invNo);
      setOriginalInvoiceId(invId);

      sessionStorage.setItem("exchangeRefundCredit", refundCredit);
      sessionStorage.setItem("originalInvoiceNo", invNo);
      sessionStorage.setItem("originalInvoiceId", invId || "");

      // Populate returned items with a negative quantity into the invoice items list!
      const constructedReturnedItems = items.map(item => {
        const rate = Number(item.rate) || 0;
        const quantity = -Number(item.qty); // Negative quantity!
        const basic_amount = rate * quantity;
        const taxPercent = Number(item.tax || 0);
        const taxAmount = taxPercent > 0 ? (basic_amount * taxPercent) / (100 + taxPercent) : 0;
        const total_amount = basic_amount;

        return {
          id: null,
          product_id: item.product_id,
          product_code: item.product_code,
          code: item.product_code,
          product_name: item.product_title,
          label: item.product_title,
          units: item.units,
          selected_unit: item.units,
          precision: isDecimalUnit(item.units) ? 3 : 0,
          allowDecimal: isDecimalUnit(item.units),
          selected_batch: {
            id: item.counter_stock_batch_id,
            batch_code: item.batch_code,
            price: rate,
            mrp: Number(item.mrp) || 0,
            expiry_date: item.expiry_date || "",
            stock: Number(item.stock) || 0,
            total_stock: Number(item.stock) || 0,
          },
          batch_code: item.batch_code,
          qty: quantity,
          entered_qty: quantity,
          basic_amount: basic_amount,
          discountPercentage: 0,
          discount: 0,
          tax: taxPercent,
          tax_total: Number(taxAmount.toFixed(2)),
          total: total_amount,
          deleted: false,
          isReturnedItem: true, // Identify as return item
          total_avl_stock: (Number(item.stock) || 0) + Math.abs(quantity),
          counter_stock_id: item.counter_stock_id,
        };
      });

      setInvoiceItemsList(constructedReturnedItems);

      // 🔁 Update local batches stock state exactly like manual negative entry!
      items.forEach(item => {
        increaseBatchStock(item.batch_code, Number(item.qty));
      });

      setTimeout(updateTotal, 100);

      if (customer) {
        setCustomerId(customer.id);
        setCustomerSelected([customer]);
        setCustomerSearch(customer.first_name || customer.name || "");
        sessionStorage.setItem("customerId", customer.id);
      }

      showSuccessToast({
        title: "Product Returned",
        message: "Stock increased & amount reduced"
      });
    } else {
      // NORMAL FLOW: If not exchange flow, CLEAR exchange state so it doesn't leak to normal bills!
      sessionStorage.removeItem("exchangeRefundCredit");
      sessionStorage.removeItem("originalInvoiceId");
      sessionStorage.removeItem("originalInvoiceNo");
      setExchangeRefundCredit(0);
      setOriginalInvoiceNo("");
      setOriginalInvoiceId(null);
    }
  }, [location.state]);

  const coupons_data = useQuery("coupons", coupons_api.get, {
    onSuccess: data => setCoupons(data.data),
  });

  // useEffect(() => {
  //   coupons_data();
  // },[])

  const form = useForm({
    initialValues: {
      route: "",
      agents: "",
      start_date: "",
      end_date: "",
      date: new Date(),
    },
    validate: {
      agent: value => (value ? null : "Agent is required"),
      date: value => (value ? null : "Date is required"),
    },
  });

  const [packets, setPackets] = useState(0);
  const [kgs, setKgs] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [totalItems, setTotalItems] = useState(0);

  useEffect(() => {
    let qtySum = 0;
    let amountSum = 0;
    let itemCount = 0;

    invoiceItemsList.forEach(item => {
      if (!item.deleted) {
        qtySum += Number(item.entered_qty) || 0;
        amountSum += Number(item.total) || 0;
        itemCount += 1; // count how many items
      }
    });

    // Split qty into packets & kg
    const whole = Math.floor(qtySum);              // packets
    const decimal = +(qtySum - whole).toFixed(2);  // kg (2 decimal)

    setPackets(whole);
    setKgs(decimal);
    setTotalAmount(Math.round(amountSum)); // round off total amount
    setTotalItems(itemCount);
  }, [invoiceItemsList]);

  useEffect(() => {
    if (window.location.pathname.includes("/edit")) {
      setIsInvoiceEditMode(true);
      setIsEditInvoiceMode(true);
    } else {
      setIsInvoiceEditMode(false);
      setIsEditInvoiceMode(false);
    }
  }, []);
  const [customerYearlyCouponStatus, setCustomerYearlyCouponStatus] = useState(null);
  const [customerQualifiesForYearlyCoupon, setCustomerQualifiesForYearlyCoupon] = useState(false);
  const [yearlyCouponCode, setYearlyCouponCode] = useState(null);
  const [availableCoupons, setAvailableCoupons] = useState([]);
  const yearlyCouponsQuery = useQuery(
    ["yearly-coupons"],
    () => coupons_api.yearlyCouponGet(),
    {
      onSuccess: (data) => {
        if (data?.success) {
          // Store all yearly coupons
          const allYearlyCoupons = data.data?.results || [];

          // Find if current customer has a yearly coupon
          if (customerId) {
            const customerYearlyCoupon = allYearlyCoupons.find(
              coupon => coupon.user_id === parseInt(customerId)
            );

            if (customerYearlyCoupon) {
              setCustomerYearlyCouponStatus(customerYearlyCoupon);

              // Check if customer qualifies (month_count >= 11 AND active)
              const qualifies = customerYearlyCoupon.active === true &&
                customerYearlyCoupon.month_count >= 11;

              setCustomerQualifiesForYearlyCoupon(qualifies);
              setYearlyCouponCode(customerYearlyCoupon.coupon_code);
            }
          }
        }
      },
      onError: (error) => {
        console.error("Error fetching yearly coupons:", error);
      }
    }
  );
  useEffect(() => {
    setCouponCode("");
    setCouponApplied(null);
  }, [customerId]);

  // // Indha function-ah unga InvoiceMaster component-kulla add pannikonga
  // const handleItemSelection = (selectedValue) => {
  //   // Input box-la value illana, onnum panna vendam
  //   if (!selectedValue) return;

  //   let productCode = selectedValue;
  //   let batchCode = null;

  //   // User 'product_code-batch_code' format-la kuduthirukara nu check pannurom
  //   if (selectedValue.includes("-")) {
  //     const parts = selectedValue.split("-");
  //     productCode = parts[0];
  //     batchCode = parts[1];
  //   }

  //   // Kudutha productCode-ah vechu, productsList-la irundhu correct product-ah edukurom
  //   const productToAdd = productsList.find((e) => e.code === productCode);

  //   // Appadi oru product-ey illana, error kaatitu stop pannidrom
  //   if (!productToAdd) {
  //     showErrorToast({ title: "Error", message: "Product not found." });
  //     return;
  //   }

  //   let batchToSelect = null;

  //   // User oru batch code kuduthirundha, andha specific batch-ah thedrom
  //   if (batchCode) {
  //     batchToSelect = productToAdd.batches.find(
  //       (b) => b.batch_code.toLowerCase() === batchCode.toLowerCase()
  //     );

  //     // Andha specific batch illana, error kaatidrom
  //     if (!batchToSelect) {
  //       showErrorToast({
  //         title: "Error",
  //         message: `Batch '${batchCode}' not found for this product.`,
  //       });
  //       return;
  //     }
  //   } else {
  //     // User batch code kudukalana, default-ah mudhal batch-ah select pannikalam
  //     if (productToAdd.batches && productToAdd.batches.length > 0) {
  //       batchToSelect = productToAdd.batches[0];
  //     } else {
  //       // Product-ku batch-ey illana, error kaatidrom
  //       showErrorToast({
  //         title: "Error",
  //         message: "This product has no available stock/batches.",
  //       });
  //       return;
  //     }
  //   }

  //   // Indha batch ippove invoice list-la iruka nu check pannurom
  //   if (invoiceItemsList.some((item) => item.batch_code === batchToSelect.batch_code)) {
  //     showErrorToast({
  //       title: "Error",
  //       message: "This product with the same batch is already in the invoice.",
  //     });
  //     return;
  //   }

  //   // Invoice table-la add panna, oru pudhu item-ah create pannurom
  //   const newItem = {
  //     ...productToAdd, // product name, tax madhiri details
  //     selected_batch: batchToSelect, // select panna batch details
  //     batch_code: batchToSelect.batch_code, // batch code mattum
  //     qty: 0,
  //     entered_qty: 0,
  //     total: 0,
  //     basic_amount: 0,
  //     tax_total: 0,
  //     discount: 0,
  //     discountPercentage: 0,
  //     deleted: false,
  //     id: null, // pudhu item-ku 'id' eppovum null ah irukanum
  //   };

  //   // Create panna item-ah invoice list-la add pannurom
  //   addInvoiceItem(newItem);

  //   // Pudhusa add panna item-oda 'Qty' input-ku focus kondu poga idhu help pannum
  //   setSelectValue(productCode);
  //   setFocus(true);
  // };


  const fetchCustomerReferralCoupons = async (customerId) => {
    if (!customerId) {
      setReferralCoupons([]);
      return;
    }

    try {
      const response = await coupons_api.referralCouponsGet({
        user_id: customerId,
        // source: 'referral'
      });
      // console.log(response)
      if (response?.success) {
        const activeCoupons = (response?.data || []).filter(coupon => {
          // Check if not used
          if (coupon.used === true) {
            console.log(`Coupon ${coupon.code} is already used`);
            return false;
          }

          // Check if not expired
          if (coupon.expiry_date) {
            const currentDate = new Date();
            const expiryDate = new Date(coupon.expiry_date);
            if (currentDate > expiryDate) {
              console.log(`Coupon ${coupon.code} is expired`);
              return false;
            }
          }

          return true;
        });

        // Format coupons for consistency
        const formattedCoupons = activeCoupons.map(coupon => ({
          ...coupon,
          coupon_code: coupon.coupon_code || coupon.code,
          active: true,
          business_type: coupon.source
        }));

        console.log("Active formatted referral coupons:", formattedCoupons);
        setReferralCoupons(formattedCoupons);

      } else {
        console.error("API returned unsuccessful:", response);
        setReferralCoupons([]);
      }

    } catch (error) {
      console.error('Error fetching referral coupons:', error);
      showErrorToast({
        title: "Error",
        message: "Failed to fetch referral coupons"
      });
      setReferralCoupons([]);
    }
  };
  const applyReferralCoupon = () => {
    if (!referralCouponCode.trim()) {
      setReferralCouponError("Please enter a referral coupon code");
      return;
    }

    // Check if coupon exists in customer's referral coupons
    const coupon = referralCoupons.find(c =>
      c.code.toLowerCase() === referralCouponCode.toLowerCase() ||
      c.coupon_code.toLowerCase() === referralCouponCode.toLowerCase()
    );

    if (!coupon) {
      setReferralCouponError("Invalid or unavailable referral coupon");
      showErrorToast({
        title: "Invalid Coupon",
        message: "This referral coupon is not available for this customer"
      });
      return;
    }

    // Check if coupon is already used
    if (coupon.used === true || coupon.active === false) {
      setReferralCouponError("This coupon has already been used");
      showErrorToast({
        title: "Coupon Used",
        message: "This referral coupon has already been used"
      });
      return;
    }

    // Check minimum purchase requirement
    const subtotal = getTotal("subtotal");
    const minPurchase = coupon.min_purchase || coupon.cutoff_amount || 0;

    if (subtotal < minPurchase) {
      setReferralCouponError(`Minimum purchase of ₹${coupon.min_purchase} required`);
      showErrorToast({
        title: "Minimum Purchase Required",
        message: `This coupon requires minimum purchase of ₹${coupon.min_purchase}`
      });
      return;
    }

    // Check expiry date
    if (coupon.expiry_date) {
      const currentDate = new Date();
      const expiryDate = new Date(coupon.expiry_date);
      if (currentDate > expiryDate) {
        setReferralCouponError("This coupon has expired");
        showErrorToast({
          title: "Coupon Expired",
          message: "This referral coupon has expired"
        });
        return;
      }

    }

    // All validations passed - apply coupon
    setSelectedReferralCoupon(coupon);
    setReferralCouponApplied(true);
    setCouponApplied({}); // Clear any regular coupon
    setCouponCode({ coupon_code: "" }); // Clear regular coupon input
    setReferralCouponError("");

    showSuccessToast({
      title: "Success",
      message: `Referral coupon ${coupon.code || coupon.coupon_code} applied successfully!`
    });
    updateTotal();
  };

  const removeReferralCoupon = () => {
    setReferralCouponCode("");
    setSelectedReferralCoupon(null);
    setReferralCouponApplied(false);
    setReferralCouponError("");
    // Also clear the input field if it exists
    const referralInput = document.querySelector('input[placeholder*="Referral"]');
    if (referralInput) referralInput.value = "";
    showSuccessToast({
      title: "Coupon Removed",
      message: "Referral coupon has been removed"
    });
    updateTotal();
  };
  const [isCustomerHighlighted, setIsCustomerHighlighted] = useState(false);
  const isDecimalUnit = (unit) => {
    if (!unit) return false;
    const lowerUnit = unit.toLowerCase();
    const decimalUnits = ['kgs', 'gm', 'kg', 'gram', 'ltr', 'ml', 'mtr'];
    return decimalUnits.includes(lowerUnit);
  };


  const { totalPcs, totalKgs } = React.useMemo(() => {
    let pcs = 0; // Pcs/Nos (Whole Numbers)
    let kgs = 0; // Kgs (Decimal Numbers)

    // *** STEP 2A: invoiceItemsList ஒரு valid Array என்பதை உறுதிப்படுத்தவும் ***
    if (!Array.isArray(invoiceItemsList)) {
      return { totalPcs: 0, totalKgs: 0 };
    }

    invoiceItemsList.forEach(item => {
      // *** STEP 2B: item மற்றும் அதன் key values இருக்கிறதா என சரிபார்க்கவும் ***
      // 'units' ஃபீல்டில் தான் அலகு வருகிறது.
      if (!item || !item.units || !item.qty) {
        return; // இந்த item-ஐத் தவிர்த்து அடுத்த item-க்குச் செல்கிறது
      }

      const qty = parseFloat(item.qty) || 0;
      const unit = item.units; // 'units' என்று சரியாகப் பயன்படுத்தப்பட்டுள்ளது

      // அலகு வகையைப் பொறுத்து மொத்த அளவைச் சேர்த்தல்
      if (isDecimalUnit(unit)) {
        // KGS/GRMS போன்ற தசம அலகுகள்: முழு எண்ணாக இருந்தாலும் KGS-ல் சேரும்.
        kgs += qty;
      } else {
        // PCS/NOS போன்ற முழு எண் அலகுகள்.
        pcs += qty;
      }
    });

    return { totalPcs: pcs, totalKgs: kgs };
  }, [invoiceItemsList]);

  const updateQty = (batchCode, data, code) => {
    const current_item = invoiceItemsList.find(item => item.code === code);
    console.log("Current modifying item :", current_item);

    let qty_to_fill = 0;

    setInvoiceItemsList(
      produce(draft => {
        const item = draft.find(item => item.code === code);
        const batchIndex = item.batches.findIndex(e => e.batch_code === batchCode);

        const is_qty_overflow = data > item.selected_batch.total_stock;

        if (is_qty_overflow) {
          const usedFromSelected = item.selected_batch.total_stock;
          item.entered_qty = usedFromSelected;
          item.qty = usedFromSelected;
          item.basic_amount = item.selected_batch.price * usedFromSelected;
          updateBatch(item.product_code, batchIndex, 0);
          item.selected_batch.stock = 0;

          qty_to_fill = data - usedFromSelected;
          handleBatches(
            current_item.product_code,
            batchCode,
            qty_to_fill,
            batchIndex
          );
        } else {
          item.qty = +data;
          item.entered_qty = +data;
          item.basic_amount = item.selected_batch.price * data;
          updateBatch(item.product_code, batchIndex, item.selected_batch.total_stock - data);
          item.selected_batch.stock = item.selected_batch.total_stock - data;
        }
      })
    );
    setTimeout(updateTotal, 100);
  };

  // Add these state variables with your other useState declarations
  const [editingItem, setEditingItem] = useState(null);
  const [editStep, setEditStep] = useState(''); // 'batch', 'qty', 'disc'
  const [editProductName, setEditProductName] = useState('');
  const [editBatchCode, setEditBatchCode] = useState('');
  const [editQty, setEditQty] = useState('');
  const [editDiscount, setEditDiscount] = useState('');
  const [isEditingMode, setIsEditingMode] = useState(false);

  // Edit functionality functions
  const handleEditItem = (item) => {
    if (isEditingMode && editingItem?.uniqueId !== item.uniqueId) {
      showErrorToast({
        title: "Editing in Progress",
        message: "Please finish editing the current item first"
      });
      return;
    }

    const uniqueId = `${item.product_code}_${item.batch_code}`;
    setSelectedRow(uniqueId); // Keep row selected when editing
    setEditingItem({
      ...item,
      uniqueId: `${item.product_code}_${item.batch_code}` // Create unique identifier
    });
    setIsEditingMode(true);
    setSelectedProductCode(item.code || item.product_code);
    setSelectedProductName(item.product_name || item.label || "");
    setEditProductName(item.product_name || item.label || "");
    setEditBatchCode(item.batch_code || "");
    setEditQty(item.qty || "");
    setEditDiscount(item.discountPercentage || 0);
    setSelectedBatchCode(item.batch_code); // Reset batch code to allow fresh selection
    setTempQty(item.qty || "");
    setTempDiscount(item.discountPercentage || 0);
    // Force show ALL batches for this product (including out of stock)
    // showAllBatchesForProduct(item.product_code);
    // setProductSelectionModal(true);
    // AUTO-LOAD batches in background
    updateModalBatches(item.product_code);

    // Auto-focus on quantity
    setTimeout(() => {
      document.getElementById("temp_qty_input")?.focus();
      document.getElementById("temp_qty_input")?.select();
    }, 100);
  };
  // Handle row click for selection
  const handleRowClick = (uniqueId, item) => {
    if (isEditingMode) {
      showErrorToast({
        title: "Editing in Progress",
        message: "Please finish editing the current item first"
      });
      return;
    }

    setSelectedRow(uniqueId);
    setTimeout(() => {
      handleEditItem(item);
    }, 300);
  };
  const showAllBatchesForProduct = (productCode) => {
    console.log("Showing ALL batches for product:", productCode);

    // Find the product in productsList first to get the correct product_code
    const productFromList = productsList.find(
      (product) => product.code === productCode || product.product_code === productCode
    );

    if (!productFromList) {
      console.log("Product not found in productsList");
      setModalBatches([]);
      return;
    }

    // Now find the batches for this product from the original batches data
    const productBatch = batches.find(
      (batch) => batch.product_code === productFromList.product_code || batch.product_code === productCode
    );

    console.log("Found product batch with ALL batches:", productBatch);

    if (!productBatch || !productBatch.batches) {
      console.log("No batches found for product");
      setModalBatches([]);
      return;
    }

    // Show ALL batches without filtering out any
    const allBatchesData = productBatch.batches.map(batch => ({
      ...batch,
      product_code: productBatch.product_code
    }));

    console.log("Showing ALL batches:", allBatchesData);
    setModalBatches(allBatchesData);
  };

  const handleBatchSelectInEdit = (batch) => {
    const product = productsList.find(p => p.product_code === batch.product_code);
    if (product?.has_pending_merge) {
      showErrorToast({
        title: "Merge Approval Required",
        message: "This product has a pending batch merge. Please complete the approval process before billing."
      });
      return;
    }
    // ✅ FIRST: Return the existing quantity to the ORIGINAL batch stock
    if (editingItem) {
      setBatches(
        produce(draft => {
          const originalProductBatch = draft.find(p => p.product_code === editingItem.product_code);
          if (originalProductBatch) {
            const originalBatchIndex = originalProductBatch.batches.findIndex(
              b => b.batch_code === editingItem.batch_code
            );
            if (originalBatchIndex !== -1) {
              // Return the existing quantity back to original batch stock
              originalProductBatch.batches[originalBatchIndex].stock += editingItem.qty;
            }
          }
        })
      );
    }

    setSelectedBatchCode(batch.batch_code);
    setProductSelectionModal(false);

    setTimeout(() => {
      document.getElementById("temp_qty_input")?.focus();
      document.getElementById("temp_qty_input")?.select();
    }, 150);
  };

  const handleEditWithOverflow = (productToEdit, selectedBatch, totalQuantity, discountPercent, originalQuantity) => {
    const productCode = productToEdit.product_code;

    // Find the product in batches to get all available batches
    const productBatch = batches.find(p => p.product_code === productCode);
    if (!productBatch) return;

    // Find index of selected batch
    const selectedIndex = productBatch.batches.findIndex(b => b.batch_code === selectedBatch.batch_code);
    if (selectedIndex === -1) return;

    let qty_to_fill = totalQuantity;
    const itemsToUpdate = [];

    console.log(`🔄 Starting overflow edit: ${totalQuantity} units needed`);

    setBatches(
      produce(draft => {
        const productBatches = draft.find(p => p.product_code === productCode).batches;

        // 1️⃣ First, use as much as possible from selected batch (using TOTAL stock)
        const selectedBatchTotalStock = productBatches[selectedIndex].total_stock;
        const selectedBatchCurrentStock = productBatches[selectedIndex].stock;

        // For selected batch, we can use up to its TOTAL stock
        const availableFromSelected = selectedBatchTotalStock;
        const usedFromSelected = Math.min(availableFromSelected, qty_to_fill);

        console.log(`📍 Selected batch ${selectedBatch.batch_code}: total_stock=${selectedBatchTotalStock}, using=${usedFromSelected}`);

        if (usedFromSelected > 0) {
          // Update stock: current stock minus what we're using
          const newStock = Math.max(0, selectedBatchCurrentStock - usedFromSelected);
          productBatches[selectedIndex].stock = newStock;

          qty_to_fill -= usedFromSelected;

          const selectedBatchItem = createCompleteInvoiceItem(
            productToEdit,
            {
              ...productBatches[selectedIndex],
              stock: newStock
            },
            usedFromSelected, // Only the allocated portion
            discountPercent
          );
          itemsToUpdate.push(selectedBatchItem);
          console.log(`✅ Added selected batch item: ${usedFromSelected} units`);
        }

        // 2️⃣ CONTINUOUS PASS: Keep using batches BELOW selected batch until no more available
        let passCount = 1;
        while (qty_to_fill > 0) {
          let foundStockInBelowBatches = false;

          console.log(`📦 PASS ${passCount} - Need ${qty_to_fill} units from batches BELOW (indices ${selectedIndex + 1} to ${productBatches.length - 1})`);

          for (let i = selectedIndex + 1; i < productBatches.length; i++) {
            if (qty_to_fill <= 0) break;

            const batch = productBatches[i];
            if (batch.stock > 0) {
              const take = Math.min(batch.stock, qty_to_fill);
              if (take > 0) {
                productBatches[i].stock = Math.max(0, batch.stock - take);
                qty_to_fill -= take;
                foundStockInBelowBatches = true;

                const additionalItem = createCompleteInvoiceItem(
                  productToEdit,
                  batch,
                  take,
                  discountPercent
                );
                itemsToUpdate.push(additionalItem);
                console.log(`✅ PASS ${passCount} - Added BELOW batch ${batch.batch_code} (index ${i}): ${take} units`);
              }
            }
          }

          // If no more stock found in below batches, break the loop
          if (!foundStockInBelowBatches) {
            console.log(`🛑 No more stock available in below batches after ${passCount} passes`);
            break;
          }

          passCount++;
        }

        // 3️⃣ FINAL PASS: If STILL needed, start from FIRST batch in the list and go sequentially

        if (qty_to_fill > 0) {
          console.log(`📦 Still need ${qty_to_fill} units from other batches`);

          for (let i = 0; i < productBatches.length; i++) {
            // if (i === selectedIndex) continue; // Skip selected batch (already used)
            if (qty_to_fill <= 0) break;

            // Skip batches that were already used in previous steps
            const batchAlreadyUsed = itemsToUpdate.some(item => item.batch_code === productBatches[i].batch_code);
            if (batchAlreadyUsed) continue;

            const batch = productBatches[i];
            if (batch.stock > 0) {
              const take = Math.min(batch.stock, qty_to_fill);
              if (take > 0) {
                productBatches[i].stock = Math.max(0, batch.stock - take);
                qty_to_fill -= take;

                const additionalItem = createCompleteInvoiceItem(
                  productToEdit,
                  batch,
                  take, // Only take what's needed
                  discountPercent
                );
                itemsToUpdate.push(additionalItem);
                console.log(`✅ Added additional batch ${batch.batch_code}: ${take} units`);
              }
            }
          }
        }
      })
    );

    // ✅ CRITICAL FIX: Wait for batches to update, then update invoice items
    setTimeout(() => {
      setInvoiceItemsList(
        produce(draft => {
          // Remove the original editing item
          const originalIndex = draft.findIndex(item =>
            item.batch_code === editingItem.batch_code &&
            item.product_code === editingItem.product_code
          );
          if (originalIndex !== -1) {
            draft.splice(originalIndex, 1);
            console.log(`🗑️ Removed original item with batch ${editingItem.batch_code}`);
          }

          // 🔑 MERGE OR CREATE (NO DUPLICATES)
          itemsToUpdate.forEach(item => {
            const existingIndex = draft.findIndex(d =>
              d.product_code === item.product_code &&
              d.batch_code === item.batch_code &&
              d.deleted === false
            );

            if (existingIndex !== -1) {
              // ✅ MERGE
              draft[existingIndex].qty += item.qty;
              draft[existingIndex].entered_qty += item.qty;
              draft[existingIndex].basic_amount += item.basic_amount;
            } else {
              // ✅ CREATE (ONLY IF NOT EXISTS)
              draft.unshift({
                ...item,
                id: null
              });
            }
          });
        })
      );

      // Verify the total
      const totalAdded = itemsToUpdate.reduce((sum, item) => sum + item.qty, 0);
      console.log(`🎯 Total added across batches: ${totalAdded}, Requested: ${totalQuantity}`);

      if (totalAdded !== totalQuantity) {
        console.error(`❌ Quantity mismatch: Added ${totalAdded} but requested ${totalQuantity}`);
      }

      updateTotal();

      // Show success message with batch breakdown
      if (itemsToUpdate.length > 1) {
        showSuccessToast({
          title: "Stock Distributed",
          message: `Quantity distributed across ${itemsToUpdate.length} batches`
          // message: `Quantity distributed across ${itemsToUpdate.length} batches: ${itemsToUpdate.map(item => `${item.batch_code} (${item.qty})`).join(', ')}`
        });
      }

      // Reset edit state
      setEditingItem(null);
      setIsEditingMode(false);
      handleClearSelection();
    }, 100);
  };
  // ✅ UPDATED: Handle single batch editing (no overflow)
  const handleSingleBatchEdit = (productToEdit, batchToEdit, quantity, discountPercent, originalQuantity) => {
    // Check if this would create a duplicate (if changing to existing batch)
    if (selectedBatchCode && selectedBatchCode !== editingItem.batch_code) {
      const existingItem = invoiceItemsList.find(
        item => item.product_code === productToEdit.product_code &&
          item.batch_code === selectedBatchCode &&
          item.batch_code !== editingItem.batch_code // Exclude the current editing item
      );

      if (existingItem) {
        showErrorToast({
          title: "Error",
          message: "This product and batch combination is already in the invoice!",
        });
        return;
      }
    }

    // Update batches state
    setBatches(
      produce(draft => {
        const productBatch = draft.find(p => p.product_code === productToEdit.product_code);
        if (productBatch) {
          // If changing batches, return original quantity to original batch
          if (selectedBatchCode && selectedBatchCode !== editingItem.batch_code) {
            const originalBatchIndex = productBatch.batches.findIndex(
              b => b.batch_code === editingItem.batch_code
            );
            if (originalBatchIndex !== -1) {
              productBatch.batches[originalBatchIndex].stock += originalQuantity;
            }
          }

          // Deduct new quantity from target batch
          const targetBatchIndex = productBatch.batches.findIndex(b => b.batch_code === batchToEdit.batch_code);
          if (targetBatchIndex !== -1) {
            const newStock = Math.max(0, productBatch.batches[targetBatchIndex].stock - quantity);
            productBatch.batches[targetBatchIndex].stock = newStock;
          }
        }
      })
    );

    // Update the invoice item
    setInvoiceItemsList(
      produce(draft => {
        const item = draft.find(i => i.product_code === editingItem.product_code &&
          i.batch_code === editingItem.batch_code);

        if (item) {
          // If batch was changed, update batch details
          if (selectedBatchCode && selectedBatchCode !== editingItem.batch_code) {
            const newBatch = productToEdit.batches.find(b => b.batch_code === selectedBatchCode);
            if (newBatch) {
              item.selected_batch = {
                ...newBatch,
                stock: newBatch.stock - quantity
              };
              item.batch_code = newBatch.batch_code;
              item.expiry_date = newBatch.expiry_date;
            }
          }

          // Update quantity and recalculate amounts
          item.qty = quantity;
          item.entered_qty = quantity;
          item.basic_amount = item.selected_batch.price * quantity;
          item.discountPercentage = discountPercent;
          item.discount = (item.basic_amount * discountPercent) / 100;

          const reduced_rate = item.basic_amount - item.discount;
          const taxPercentage = item.tax || 0;
          const denominator = 100 + taxPercentage;
          const tax = (reduced_rate - (reduced_rate / denominator) * 100).toFixed(2);

          item.tax_total = Number(tax);
          item.total = reduced_rate;
        }
      })
    );
  };
  const handleEditEnter = () => {
    if (!isEditingMode || !editingItem) return;

    const qty = parseFloat(editingItem.qty);
    if (isNaN(qty) || qty === 0) {
      showErrorToast({
        title: "Invalid Qty",
        message: "Quantity cannot be zero"
      });
      return;
    }

    const batchCode = selectedBatchCode || editingItem.batch_code;

    // 🔴 NEGATIVE QTY (RETURN CASE)
    if (qty < 0) {
      const returnQty = Math.abs(qty);

      // 1️⃣ Increase stock
      increaseBatchStock(batchCode, returnQty);
      // await syncBatchStockToDB(batchCode, returnQty);
      // console.log("qty negetive",editingItem)

      const taxPercent = Number(editingItem.tax || 0);

      // 2️⃣ UPDATE invoice row with negative qty & total
      setInvoiceItemsList(prev =>
        prev.map(item => {
          if (
            item.product_code === editingItem.product_code &&
            item.batch_code === editingItem.batch_code
          ) {
            const basicAmount = item.selected_batch.price * qty; // NEGATIVE

            // ✅ Correct tax calculation (same logic as updateTotal)
            const taxAmount =
              taxPercent > 0
                ? (basicAmount * taxPercent) / (100 + taxPercent)
                : 0;

            return {
              ...item,
              qty: qty,
              entered_qty: qty,
              tax: taxPercent,                       // 🔥 REQUIRED
              basic_amount: basicAmount,
              discount: 0,
              tax_total: Number(taxAmount.toFixed(2)), // 🔥 NEGATIVE TAX
              total: basicAmount + taxAmount           // 🔥 NEGATIVE TOTAL
            };
          }
          return item;
        })
      );

      updateTotal();

      showSuccessToast({
        title: "Product Returned",
        message: `Stock increased & amount reduced`
      });

      // 3️⃣ Exit edit mode cleanly
      setEditingItem(null);
      setIsEditingMode(false);
      setSelectedRow(null);
      handleClearSelection();

      return; // 🚨 STOP here
    }
    if (!editingItem || !editingItem.qty) {
      showErrorToast({
        title: "Error",
        message: "Please enter valid quantity!"
      });
      return;
    }

    const quantity = parseFloat(editingItem.qty) || 0;
    const discountPercent = parseFloat(editingItem.discountPercentage) || 0;

    if (quantity <= 0) {
      showErrorToast({
        title: "Error",
        message: "Please enter a valid quantity!"
      });
      return;
    }

    // Find the product and batch details
    const productToEdit = productsList.find(p => p.product_code === editingItem.product_code);

    if (productToEdit?.has_pending_merge) {
      showErrorToast({
        title: "Merge Approval Required",
        message: "This product has a pending batch merge. Please complete the approval process before billing."
      });
      return;
    }

    const targetBatchCode = selectedBatchCode || editingItem.batch_code;
    const batchToEdit = productToEdit?.batches.find(b => b.batch_code === targetBatchCode);

    if (!productToEdit || !batchToEdit) {
      showErrorToast({
        title: "Error",
        message: "Product or batch not found!"
      });
      return;
    }

    // ✅ CALCULATE TOTAL AVAILABLE STOCK CORRECTLY FOR EDITING
    const productBatch = batches.find(p => p.product_code === editingItem.product_code);
    let totalAvailableStock = 0;

    if (productBatch?.batches) {
      const targetBatchCode = selectedBatchCode || editingItem.batch_code;

      // Find the selected batch first
      const selectedBatch = productBatch.batches.find(b => b.batch_code === targetBatchCode);
      if (selectedBatch) {
        // Add selected batch's TOTAL stock
        totalAvailableStock += selectedBatch.total_stock || 0;
      }

      // Add other batches' CURRENT stock
      productBatch.batches.forEach(batch => {
        if (batch.batch_code !== targetBatchCode) {
          totalAvailableStock += batch.stock || 0;
        }
      });
    }
    totalAvailableStock = parseFloat(totalAvailableStock.toFixed(2));
    console.log(`Edit - Total available: ${totalAvailableStock} (Selected batch total + Other batches current)`);

    // ✅ Check if total quantity exceeds available stock
    if (quantity > totalAvailableStock) {
      showErrorToast({
        title: "Insufficient Stock",
        message: `Only ${totalAvailableStock} units available `
      });
      return;
    }

    // ✅ OVERFLOW LOGIC FOR EDITING MODE - Check against selected batch's TOTAL stock
    const is_qty_overflow = quantity > batchToEdit.total_stock;

    if (is_qty_overflow) {
      // Use overflow logic - distribute quantity across multiple batches
      handleEditWithOverflow(
        productToEdit,
        batchToEdit,
        quantity,
        discountPercent,
        editingItem.qty || 0
      );
      return;
    } else {
      // Normal case - selected batch has sufficient TOTAL stock
      handleSingleBatchEdit(
        productToEdit,
        batchToEdit,
        quantity,
        discountPercent,
        editingItem.qty || 0
      );
    }
    // Update the invoice list with edited values
    setInvoiceItemsList(
      produce(draft => {
        const item = draft.find(i => i.product_code === editingItem.product_code &&
          i.batch_code === editingItem.batch_code);
        if (item) {
          item.qty = quantity;
          item.entered_qty = quantity;
          item.discountPercentage = discountPercent;

          // Recalculate amounts
          item.basic_amount = item.selected_batch.price * quantity;
          item.discount = (item.basic_amount * discountPercent) / 100;

          const reduced_rate = item.basic_amount - item.discount;
          const taxPercentage = item.tax || 0;
          const denominator = 100 + taxPercentage;
          const tax = (reduced_rate - (reduced_rate / denominator) * 100).toFixed(2);

          item.tax_total = Number(tax);
          item.total = reduced_rate;
        }
      })
    );
    // Update totals
    updateTotal();

    // Show success message
    showSuccessToast({
      title: "Success",
      message: "Product edited successfully!"
    });

    // Reset edit state
    setSelectedRow(null);
    setIsListFocused(false);
    setEditingItem(null);
    setIsEditingMode(false);
    handleClearSelection();

    // Refocus to search bar for new product
    setTimeout(() => {
      const searchInput = document.querySelector('input[placeholder*="add Invoice Item"]');
      if (searchInput) {
        searchInput.focus();
        searchInput.select();
      }
    }, 100);
  };

  const cancelEdit = () => {
    if (editingItem) {
      // Show confirmation message
      showSuccessToast({
        title: "Edit Cancelled",
        message: "Changes discarded and original product restored"
      });
    }

    // Reset edit state and clear fields
    setEditingItem(null);
    setIsEditingMode(false);
    setSelectedRow(null);
    setIsListFocused(false);
    setEditStep('');
    setEditProductName('');
    setEditBatchCode('');
    setEditQty('');
    setEditDiscount('');

    // Clear the product search fields
    handleClearSelection();

    // Refocus to search bar for new product
    setTimeout(() => {
      const searchInput = document.querySelector('input[placeholder*="add Invoice Item"]');
      if (searchInput) {
        searchInput.focus();
        searchInput.select();
      }
    }, 100);
  };

  // Add keyboard navigation for edit flow
  useEffect(() => {
    const handleEditKeyDown = (event) => {
      if (!editingItem) return;

      if (event.key === 'Escape') {
        cancelEdit();
      } else if (event.key === 'Enter') {
        if (editStep === 'batch') {
          // Auto-select first available batch if in batch selection
          if (modalBatches.length > 0 && !editBatchCode) {
            handleBatchSelectInEdit(modalBatches[0]);
          }
        } else if (editStep === 'qty') {
          setEditStep('disc');
          setTimeout(() => {
            const discountInput = document.getElementById(`edit_discount_${editingItem.batch_code}`);
            if (discountInput) {
              discountInput.focus();
              discountInput.select();
            }
          }, 150);
        } else if (editStep === 'disc') {
          handleEditEnter();
        }
      }
    };

    window.addEventListener('keydown', handleEditKeyDown);
    return () => window.removeEventListener('keydown', handleEditKeyDown);
  }, [editingItem, editStep, editBatchCode, modalBatches]);

  // Add these state variables with your other useState declarations
  const [selectedProductCode, setSelectedProductCode] = useState(null);
  const [selectedProductName, setSelectedProductName] = useState("");
  const [selectedBatchCode, setSelectedBatchCode] = useState(null);
  const [selectedBatchName, setSelectedBatchName] = useState("");
  const [tempQty, setTempQty] = useState("");
  const [tempDiscount, setTempDiscount] = useState("");

  const [totalBatchQty, setTotalBatchQty] = useState(0);

  useEffect(() => {

    // Decide which product code to use
    const productCode = isEditingMode
      ? editingItem?.product_code
      : selectedProductCode;

    if (!productCode) {
      setTotalBatchQty(0);
      return;
    }

    const product = productsList?.find(
      (p) => p.code === productCode || p.product_code === productCode
    );

    if (!product?.batches) {
      setTotalBatchQty(0);
      return;
    }

    const total = product.batches.reduce((sum, batch) => {
      return sum + (Number(batch.stock) || 0);
    }, 0);

    console.log("Total batch quantity:", total, product, productsList);
    setTotalBatchQty(total.toFixed(3));

  }, [selectedProductCode, isEditingMode, editingItem, productsList]);

  // Clear function to reset only the current product selection
  const handleClearSelection = () => {
    setTempQty("");
    setTempDiscount("");
    setSearchValue("");
    setSelectedProductCode(null);
    setSelectedProductName("");
    setSelectedBatchCode(null);
    setSelectedBatchName("");
    setCurrentBatch({});

    // Refocus to product search immediately
    setTimeout(() => {
      const searchInput = document.querySelector('input[placeholder*="add Invoice Item"]');
      if (searchInput) {
        searchInput.focus();
        searchInput.select();
      }
    }, 50);
  };
  // Add this reset function:
  const resetAddProductFields = () => {
    setTempQty("");
    setTempDiscount("");
    setSearchValue("");
    setSelectedBatchCode(null);
    setSelectedProductName("");
    setSelectedBatchName("");
    // Refocus to product search
    setTimeout(() => {
      const searchInput = document.querySelector('input[placeholder*="add Invoice Item"]');
      if (searchInput) searchInput.focus();
    }, 100);
  };

  // Update the batch selection handler:
  const handleBatchSelect = newBatch => {
    const product = productsList.find(p => p.product_code === newBatch.product_code);
    if (product?.has_pending_merge) {
      showErrorToast({
        title: "Merge Approval Required",
        message: "This product has a pending batch merge. Please complete the approval process before billing."
      });
      return;
    }
    if (newBatch?.product_code) {
      resetBatchQty(newBatch?.product_code);
    }

    // ✅ CHECK IF PRODUCT+BATCH ALREADY EXISTS IN INVOICE
    const existingItem = invoiceItemsList.find(
      item => item.product_code === newBatch.product_code &&
        item.batch_code === newBatch.batch_code
    );

    if (existingItem) {
      // ✅ AUTOMATICALLY SWITCH TO EDITING MODE FOR THIS ITEM
      handleEditItem(existingItem);

      // Show informative message
      showSuccessToast({
        title: "Editing Mode Activated",
        message: `You're now editing ${existingItem.product_name} (${existingItem.batch_code})`
      });

      setProductSelectionModal(false);
      return; // Stop further execution
    }

    setSelectedBatchCode(newBatch.batch_code);
    setSelectedBatchName(newBatch.batch_code);

    setProductSelectionModal(false);

    // Auto-focus to quantity input only if product is not already in invoice
    setTimeout(() => {
      document.getElementById("temp_qty_input")?.focus();
    }, 150);
  };

  const handleProductWithOverflow = (productToAdd, selectedBatch, totalQuantity, discountPercent) => {
    const productCode = productToAdd.product_code;
    const batchCode = selectedBatch.batch_code;

    // Find the product in batches to get all available batches
    const productBatch = batches.find(p => p.product_code === productCode);
    if (!productBatch) return;

    // Find index of selected batch
    const selectedIndex = productBatch.batches.findIndex(b => b.batch_code === batchCode);
    if (selectedIndex === -1) return;

    let qty_to_fill = totalQuantity;
    const itemsToAdd = [];

    setBatches(
      produce(draft => {
        const productBatches = draft.find(p => p.product_code === productCode).batches;

        // 1️⃣ First, use as much as possible from selected batch (up to TOTAL stock)
        const selectedBatchTotalStock = productBatches[selectedIndex].total_stock;
        const selectedBatchCurrentStock = productBatches[selectedIndex].stock;

        // For selected batch, we can use up to its TOTAL stock (not just current stock)
        const availableFromSelected = selectedBatchTotalStock;
        const usedFromSelected = Math.min(availableFromSelected, qty_to_fill);

        if (usedFromSelected > 0) {
          // Update stock: current stock minus what we're using
          const newStock = Math.max(0, selectedBatchCurrentStock - usedFromSelected);
          productBatches[selectedIndex].stock = newStock;

          qty_to_fill -= usedFromSelected;
          // ✅ Check if this selected batch already exists in invoice
          const existingSelectedBatch = invoiceItemsList.find(
            item => item.batch_code === productBatches[selectedIndex].batch_code &&
              item.product_code === productCode
          );

          if (existingSelectedBatch) {
            // ✅ UPDATE existing batch quantity instead of creating new
            setInvoiceItemsList(
              produce(invoiceDraft => {
                const item = invoiceDraft.find(
                  i => i.batch_code === productBatches[selectedIndex].batch_code &&
                    i.product_code === productCode
                );
                if (item) {
                  const newQty = (parseFloat(item.qty) || 0) + usedFromSelected;
                  item.qty = newQty;
                  item.entered_qty = newQty;
                  item.basic_amount = item.selected_batch.price * newQty;

                  // Recalculate discount and total
                  const discountAmount = (item.basic_amount * item.discountPercentage) / 100;
                  item.discount = discountAmount;
                  const amountAfterDiscount = item.basic_amount - discountAmount;

                  const taxPercentage = item.tax || 0;
                  const denominator = 100 + taxPercentage;
                  const tax = (amountAfterDiscount - (amountAfterDiscount / denominator) * 100).toFixed(2);

                  item.tax_total = Number(tax);
                  item.total = amountAfterDiscount;
                }
              })
            );
          } else {
            // Create new item for selected batch

            const selectedBatchItem = createCompleteInvoiceItem(
              productToAdd,
              {
                ...productBatches[selectedIndex],
                stock: newStock
              },
              usedFromSelected,
              discountPercent
            );
            itemsToAdd.push(selectedBatchItem);
          }
        }

        // 2️⃣ CONTINUOUS PASS: Keep using batches BELOW selected batch until no more available
        let passCount = 1;
        while (qty_to_fill > 0) {
          let foundStockInBelowBatches = false;

          console.log(`📦 PASS ${passCount} - Need ${qty_to_fill} units from batches BELOW (indices ${selectedIndex + 1} to ${productBatches.length - 1})`);

          for (let i = selectedIndex + 1; i < productBatches.length; i++) {
            if (qty_to_fill <= 0) break;

            const batch = productBatches[i];
            // For other batches, only use current stock (not total_stock)
            if (batch.stock > 0) {
              const take = Math.min(batch.stock, qty_to_fill);
              if (take > 0) {
                productBatches[i].stock = Math.max(0, batch.stock - take);
                qty_to_fill -= take;
                foundStockInBelowBatches = true;
                // ✅ Check if this batch already exists in invoice
                const existingBatchItem = invoiceItemsList.find(
                  item => item.batch_code === batch.batch_code &&
                    item.product_code === productCode
                );

                if (existingBatchItem) {
                  // ✅ UPDATE existing batch quantity
                  setInvoiceItemsList(
                    produce(invoiceDraft => {
                      const item = invoiceDraft.find(
                        i => i.batch_code === batch.batch_code &&
                          i.product_code === productCode
                      );
                      if (item) {
                        const newQty = (parseFloat(item.qty) || 0) + take;
                        item.qty = newQty;
                        item.entered_qty = newQty;
                        item.basic_amount = item.selected_batch.price * newQty;

                        // Recalculate discount and total
                        const discountAmount = (item.basic_amount * item.discountPercentage) / 100;
                        item.discount = discountAmount;
                        const amountAfterDiscount = item.basic_amount - discountAmount;

                        const taxPercentage = item.tax || 0;
                        const denominator = 100 + taxPercentage;
                        const tax = (amountAfterDiscount - (amountAfterDiscount / denominator) * 100).toFixed(2);

                        item.tax_total = Number(tax);
                        item.total = amountAfterDiscount;
                      }
                    })
                  );
                } else {
                  // Create new item for this batch

                  const additionalItem = createCompleteInvoiceItem(
                    productToAdd,
                    batch,
                    take,
                    discountPercent
                  );
                  itemsToAdd.push(additionalItem);
                  console.log(`✅ PASS ${passCount} - Added BELOW batch ${batch.batch_code} (index ${i}): ${take} units`);
                }
              }
            }
          }
          // If no more stock found in below batches, break the loop
          if (!foundStockInBelowBatches) {
            console.log(`🛑 No more stock available in below batches after ${passCount} passes`);
            break;
          }

          passCount++;
        }

        // 3️⃣ FINAL PASS: If STILL needed, start from FIRST batch in the list and go sequentially
        if (qty_to_fill > 0) {
          console.log(`📦 FINAL PASS - Still need ${qty_to_fill} units, starting from FIRST batch in list`);

          for (let i = 0; i < productBatches.length; i++) {
            if (qty_to_fill <= 0) break;

            // Skip batches that were already used in previous steps
            const batchAlreadyUsed = itemsToAdd.some(item => item.batch_code === productBatches[i].batch_code);
            if (batchAlreadyUsed) continue;

            const batch = productBatches[i];
            // For other batches, only use current stock (not total_stock)
            if (batch.stock > 0) {
              const take = Math.min(batch.stock, qty_to_fill);
              if (take > 0) {
                productBatches[i].stock = Math.max(0, batch.stock - take);
                qty_to_fill -= take;
                // ✅ Check if this batch already exists in invoice
                const existingBatchItem = invoiceItemsList.find(
                  item => item.batch_code === batch.batch_code &&
                    item.product_code === productCode
                );

                if (existingBatchItem) {
                  // ✅ UPDATE existing batch quantity
                  setInvoiceItemsList(
                    produce(invoiceDraft => {
                      const item = invoiceDraft.find(
                        i => i.batch_code === batch.batch_code &&
                          i.product_code === productCode
                      );
                      if (item) {
                        const newQty = (parseFloat(item.qty) || 0) + take;
                        item.qty = newQty;
                        item.entered_qty = newQty;
                        item.basic_amount = item.selected_batch.price * newQty;

                        // Recalculate discount and total
                        const discountAmount = (item.basic_amount * item.discountPercentage) / 100;
                        item.discount = discountAmount;
                        const amountAfterDiscount = item.basic_amount - discountAmount;

                        const taxPercentage = item.tax || 0;
                        const denominator = 100 + taxPercentage;
                        const tax = (amountAfterDiscount - (amountAfterDiscount / denominator) * 100).toFixed(2);

                        item.tax_total = Number(tax);
                        item.total = amountAfterDiscount;
                      }
                    })
                  );
                } else {
                  // Create new item for this batch

                  const additionalItem = createCompleteInvoiceItem(
                    productToAdd,
                    batch,
                    take,
                    discountPercent
                  );
                  itemsToAdd.push(additionalItem);
                }
              }
            }
          }
        }
      })
    );

    // Add all items to invoice
    itemsToAdd.forEach(item => {
      addInvoiceItem(item);
    });

    updateTotal();

    // Show success message with batch breakdown
    if (itemsToAdd.length > 0) {
      const existingUpdates = (totalQuantity - qty_to_fill) - itemsToAdd.reduce((sum, item) => sum + item.qty, 0);
      const message = itemsToAdd.length > 0
        ? `Added ${itemsToAdd.length} new batch${itemsToAdd.length > 1 ? 'es' : ''}`
        : '';

      if (existingUpdates > 0) {
        const updateMsg = `Updated ${existingUpdates} unit${existingUpdates > 1 ? 's' : ''} in existing batch${existingUpdates > 1 ? 'es' : ''}`;
        showSuccessToast({
          title: "Stock Distributed",
          message: `${updateMsg} ${message ? 'and ' + message : ''}`
        });
      } else if (message) {
        showSuccessToast({
          title: "Stock Distributed",
          message: message
        });
      }
    }
  };
  // ✅ NEW: Helper function to create complete invoice items
  const createCompleteInvoiceItem = (product, batch, quantity, discountPercent) => {
    const basic_amount = batch.price * quantity;
    const discount_amount = (basic_amount * discountPercent) / 100;
    const total_amount = basic_amount - discount_amount;

    console.log(`🆕 Creating complete invoice item: ${product.product_name}, Batch: ${batch.batch_code}, Qty: ${quantity}`);

    return {
      ...product,
      // Create unique identifier for this split item
      code: `${product.code}_${batch.batch_code}_split`, // Temporary, will be made unique later
      product_name: product.product_name || product.label,
      selected_unit: product.units,
      precision: isDecimalUnit(product.units) ? 3 : 0,
      allowDecimal: isDecimalUnit(product.units),
      selected_batch: {
        ...batch,
        stock: batch.stock - quantity,
      },
      batch_code: batch.batch_code,
      qty: quantity,
      entered_qty: quantity,
      basic_amount: basic_amount,
      discountPercentage: discountPercent,
      discount: discount_amount,
      tax_total: 0,
      total: total_amount,
      deleted: false,
      id: null, // IMPORTANT: New items must have null ID
    };
  };
  // Handle single batch product (no overflow)
  const handleSingleBatchProduct = (productToAdd, batchToAdd, quantity, discountPercent) => {
    // Check if this product+batch already exists in invoice
    const existingItem = invoiceItemsList.find(
      item => item.product_code === productToAdd.product_code &&
        item.batch_code === batchToAdd.batch_code
    );

    if (existingItem) {
      showErrorToast({
        title: "Error",
        message: "This product and batch combination is already in the invoice!",
      });
      return;
    }
    // ✅ ADD STOCK VALIDATION
    if (quantity > batchToAdd.stock) {
      showErrorToast({
        title: "Insufficient Stock",
        message: `Only ${batchToAdd.stock} units available in batch ${batchToAdd.batch_code}`
      });
      setTimeout(() => {
        document.getElementById("temp_qty_input")?.focus();
        document.getElementById("temp_qty_input")?.select();
      }, 100);
      return;
    }
    // Update batches state
    setBatches(
      produce(draft => {
        const productBatch = draft.find(p => p.product_code === productToAdd.product_code);
        if (productBatch) {
          const batchIndex = productBatch.batches.findIndex(b => b.batch_code === batchToAdd.batch_code);
          if (batchIndex !== -1) {
            // ✅ SAFE DEDUCTION: Ensure we don't go negative
            const newStock = Math.max(0, productBatch.batches[batchIndex].stock - quantity);
            productBatch.batches[batchIndex].stock = newStock;
          }
        }
      })
    );

    // Create and add invoice item
    const newItem = createInvoiceItem(
      productToAdd,
      batchToAdd,
      quantity,
      discountPercent
    );

    addInvoiceItem(newItem);
    updateTotal();
  };

  // Helper function to create invoice items
  const createInvoiceItem = (product, batch, quantity, discountPercent) => {
    const basic_amount = batch.price * quantity;
    const discount_amount = (basic_amount * discountPercent) / 100;
    const total_amount = basic_amount - discount_amount;

    return {
      ...product,
      selected_unit: product.units,
      precision: isDecimalUnit(product.units) ? 3 : 0,
      allowDecimal: isDecimalUnit(product.units),
      selected_batch: {
        ...batch,
        stock: batch.stock - quantity, // Updated stock
      },
      batch_code: batch.batch_code,
      qty: quantity,
      entered_qty: quantity,
      basic_amount: basic_amount,
      discountPercentage: discountPercent,
      discount: discount_amount,
      tax_total: 0,
      total: total_amount,
      deleted: false,
      id: null,
    };
  };
  const increaseBatchStock = (batchCode, qty) => {
    setBatches(prev =>
      prev.map(product => ({
        ...product,
        batches: product.batches.map(batch =>
          batch.batch_code === batchCode
            ? {
              ...batch,
              stock: parseFloat(batch.stock) + qty,
              total_stock: parseFloat(batch.total_stock)
            }
            : batch
        )
      }))
    );
  };
  const syncBatchStockToDB = async (batchCode) => {
    // 🔍 find batch from state
    const batchObj = batches
      .flatMap(p => p.batches)
      .find(b => b.batch_code === batchCode);

    if (!batchObj || !batchObj.id) {
      // console.error("Batch not found");
      return;
    }

    const payload = {
      batches: [
        {
          id: batchObj.id,
          stock: parseFloat(batchObj.stock)
        }
      ]
    };

    await invoice_api.update_batch_stock(payload);
  };

  const handleAddProductEntry = () => {
    if (!selectedProductCode || !selectedBatchCode || !tempQty) {
      showErrorToast({
        title: "Error",
        message: "Please select product, batch and enter quantity!"
      });
      return;
    }

    const quantity = parseFloat(tempQty);

    if (isNaN(quantity) || quantity === 0) {
      showErrorToast({
        title: "Invalid Qty",
        message: "Quantity cannot be zero"
      });
      return;
    }

    const product = productsList.find(p => p.code === selectedProductCode);
    const batch = product?.batches.find(b => b.batch_code === selectedBatchCode);
    if (!product || !batch) return;

    if (product?.has_pending_merge) {
      showErrorToast({
        title: "Merge Approval Required",
        message: "This product has a pending batch merge. Please complete the approval process before billing."
      });
      return;
    }

    // 🔁 RETURN CASE (NEGATIVE QTY)
    if (quantity < 0) {
      const returnQty = Math.abs(quantity);

      // 1️⃣ increase stock
      increaseBatchStock(batch.batch_code, returnQty);
      // await syncBatchStockToDB(batch.batch_code, returnQty);


      // 2️⃣ ADD INVOICE LINE (works for + and -)
      const basicAmount = batch.price * quantity; // ← NEGATIVE
      const discount = 0;
      const total = basicAmount;
      const taxPercent = Number(product.tax || 0);
      const taxAmount =
        taxPercent > 0
          ? (basicAmount * taxPercent) / (100 + taxPercent)
          : 0;
      // console.log(product,batch)
      setInvoiceItemsList(prev => [
        ...prev,
        {
          product_code: product.product_code,
          product_name: product.product_name,
          batch_code: batch.batch_code,
          counter_stock_id: product.counter_stock_id,
          qty: quantity,
          entered_qty: quantity,
          selected_batch: batch,
          tax: taxPercent,
          basic_amount: basicAmount,
          discount,
          tax_total: Number(taxAmount.toFixed(2)),
          total, // ← NEGATIVE VALUE
          total_avl_stock: batch.stock + Math.abs(Math.min(quantity, 0))
        }
      ]);

      updateTotal(); // 🔥 THIS makes Net Total negative
      showSuccessToast({
        title: "Product Returned",
        message: `Stock increased & amount reduced`
      });
      resetAddProductFields();
      return; // 🚨 THIS IS THE KEY (stops positive flow)
    }
    const discountPercent = parseFloat(tempDiscount) || 0;

    // Find product and batch
    const productToAdd = productsList.find(p => p.code === selectedProductCode);
    const batchToAdd = productToAdd?.batches.find(b => b.batch_code === selectedBatchCode);

    if (!productToAdd || !batchToAdd) {
      showErrorToast({
        title: "Error",
        message: "Product or batch not found!"
      });
      return;
    }

    // ✅ CALCULATE TOTAL AVAILABLE STOCK CORRECTLY
    const productBatch = batches.find(p => p.product_code === productToAdd.product_code);
    let totalAvailableStock = 0;

    if (productBatch?.batches) {
      // Selected batch: can use up to total_stock
      const selectedBatch = productBatch.batches.find(b => b.batch_code === selectedBatchCode);
      if (selectedBatch) {
        totalAvailableStock += selectedBatch.total_stock || 0;
      }

      // Other batches: can only use current stock
      productBatch.batches.forEach(batch => {
        if (batch.batch_code !== selectedBatchCode) {
          totalAvailableStock += batch.stock || 0;
        }
      });
    }
    totalAvailableStock = parseFloat(totalAvailableStock.toFixed(2));
    console.log(`Total available: ${totalAvailableStock} (Selected batch total + Other batches current stock)`);

    // ✅ Check if total quantity exceeds TOTAL available stock
    if (quantity > totalAvailableStock) {
      showErrorToast({
        title: "Insufficient Stock",
        message: `Only ${totalAvailableStock} units available `
      });
      return;
    }

    // Check if this exact batch already exists in invoice
    const existingExactBatch = invoiceItemsList.find(
      item => item.product_code === productToAdd.product_code &&
        item.batch_code === selectedBatchCode
    );

    if (existingExactBatch) {
      // ✅ If exact batch exists, enter edit mode
      handleEditItem(existingExactBatch);
      return;
    }

    // ✅ Check if we need overflow logic
    const selectedBatchCurrentStock = batchToAdd.stock;
    const is_qty_overflow = quantity > selectedBatchCurrentStock;

    if (is_qty_overflow) {
      // Use overflow logic - distribute quantity across multiple batches
      console.log(`Overflow needed: ${quantity} > ${selectedBatchCurrentStock} (selected batch current stock)`);
      handleProductWithOverflow(
        productToAdd,
        batchToAdd,
        quantity,
        discountPercent
      );
    } else {
      // Normal case - selected batch has sufficient CURRENT stock
      console.log(`Single batch sufficient: ${quantity} <= ${selectedBatchCurrentStock}`);
      handleSingleBatchProduct(
        productToAdd,
        batchToAdd,
        quantity,
        discountPercent
      );
    }

    // Reset fields
    resetAddProductFields();
  };



  // const resetBatchQty = (product_code) => {
  //   const selectedProduct = batches.find(e => e.product_code === product_code);
  //   if (selectedProduct) {
  //     const resetValue=selectedProduct.batches.map(batch => ({
  //         ...batch,
  //         stock:batch?.total_stock,
  //         product_code: selectedProduct.product_code
  //       }))

  //      setModalBatches(resetValue)
  //      setBatches(batches.map((batch)=>{
  //       if(batch?.product_code === product_code){
  //         return{
  //           ...batch,
  //           batches:resetValue,
  //         }
  //       }
  //       return batch
  //      }))
  //   }
  // }

  // const updateModalBatches = product_code => {
  //   setModalBatches(batches.find(e => e.product_code === product_code).batches);
  // };

  // const resetBatchQty = (product_code) => {
  //   if (!batches || !Array.isArray(batches) || batches.length === 0) return;

  //   const updatedBatches = batches.map(product => {
  //     if (product?.product_code === product_code && Array.isArray(product.batches)) {
  //       const resetBatches = product.batches.map(batch => ({
  //         ...batch,
  //         stock: batch?.total_stock,
  //         product_code
  //       }));

  //       if (product_code === product_code) {
  //         setModalBatches(resetBatches); // Update modal batches only once
  //       }
  //       console.log('qqq-227',resetBatches)
  //       return { ...product, batches: resetBatches };
  //     }
  //     return product;
  //   });

  //   setBatches(updatedBatches);
  // };
  // Arrow key navigation between rows
  const handleArrowKeyNavigation = (key) => {
    if (!invoiceItemsList.length) return;

    const currentIndex = invoiceItemsList.findIndex(item =>
      `${item.product_code}_${item.batch_code}` === selectedRow
    );

    let newIndex;
    if (key === 'ArrowDown') {
      newIndex = currentIndex === -1 ? 0 : Math.min(currentIndex + 1, invoiceItemsList.length - 1);
    } else if (key === 'ArrowUp') {
      newIndex = currentIndex === -1 ? 0 : Math.max(currentIndex - 1, 0);
    }

    if (newIndex >= 0 && newIndex < invoiceItemsList.length) {
      const newItem = invoiceItemsList[newIndex];
      const newUniqueId = `${newItem.product_code}_${newItem.batch_code}`;
      setSelectedRow(newUniqueId);
    }
  };


  const resetBatchQty = (product_code) => {

    const batch_code = currentBatch?.batch_code

    if (!batches || !Array.isArray(batches) || batches.length === 0) return;

    const updatedBatches = batches.map(product => {
      if (product?.product_code === product_code && Array.isArray(product.batches)) {
        const resetBatches = product.batches.map(batch =>
          batch.batch_code === batch_code
            ? { ...batch, stock: batch.total_stock }  // Reset stock only for the selected batch
            : batch
        );

        return { ...product, batches: resetBatches };
      }
      return product;
    });

    const selectedProduct = updatedBatches.find(p => p.product_code === product_code);
    if (selectedProduct) {
      const selectedBatch = selectedProduct.batches.find(b => b.batch_code === batch_code);
      if (selectedBatch) {
        setModalBatches([selectedBatch]);
      }
    }

    setBatches(updatedBatches);
  };


  const updateModalBatches = (product_Code) => {
    console.log("Updating modal batches for product:", product_Code);
    // If we're in editing mode, show ALL batches
    if (isEditingMode) {
      showAllBatchesForProduct(product_Code);
      return;
    }
    // For normal mode, use your existing logic
    const productFromList = productsList.find(
      (product) => product.code === product_Code || product.product_code === product_Code
    );

    if (!productFromList) {
      console.log("Product not found in productsList");
      setModalBatches([]);
      return;
    }

    // Now find the batches for this product
    const productBatch = batches.find(
      (batch) => batch.product_code === productFromList.product_code || batch.product_code === product_Code
    );

    console.log("Found product batch:", productBatch);

    if (!productBatch || !productBatch.batches) {
      console.log("No batches found for product");
      setModalBatches([]);
      return;
    }

    let filteredBatches = [];

    if (isEditInvoiceMode) {
      // F6 FLOW (Editing saved invoice): Show ALL batches, even with zero stock
      console.log("F6 FLOW: Showing ALL batches including zero stock batches");
      filteredBatches = productBatch.batches;
    } else {
      // F5 FLOW (New invoice): Only show batches with available stock > 0
      console.log("F5 FLOW: Showing only batches with stock > 0");
      filteredBatches = productBatch.batches.filter(batch => {
        // Calculate available stock considering what's already in the invoice
        const usedInInvoice = invoiceItemsList
          .filter(item => item.batch_code === batch.batch_code &&
            item.product_code === productBatch.product_code)
          .reduce((sum, item) => sum + (parseFloat(item.qty) || 0), 0);

        const availableStock = Math.max(0, (batch.total_stock || 0) - usedInInvoice);
        return availableStock > 0;
      });
    }

    // Map batches with proper product_code
    const modalBatchesData = filteredBatches.map(batch => ({
      ...batch,
      product_code: productBatch.product_code
    }));

    console.log("Modal batches to show:", modalBatchesData);
    setModalBatches(modalBatchesData);
  };


  const updateBatchInList = newBatch => {
    if (newBatch?.product_code) {
      resetBatchQty(newBatch?.product_code);
    }

    setInvoiceItemsList(
      produce(draft => {
        // Find the current product row in the invoice items
        const selectedInvoiceItem = draft.find(
          e => e.product_code === newBatch.product_code
        );

        if (!selectedInvoiceItem) {
          console.warn("⚠️ Skipped batch update — product not found:", newBatch);
          return;
        }

        // Always allow switching to any batch inside the same product
        selectedInvoiceItem.selected_batch = newBatch;
        selectedInvoiceItem.batch_code = newBatch.batch_code;
        selectedInvoiceItem.expiry_date = newBatch.expiry_date;
        // selectedInvoiceItem.price = newBatch.price;
        selectedInvoiceItem.qty = 0;
        selectedInvoiceItem.total = 0;
        selectedInvoiceItem.total_tax = 0;
        selectedInvoiceItem.box = 0;
        selectedInvoiceItem.pieces = 0;
        selectedInvoiceItem.entered_qty = 0;

        updateTotal();
      })
    );
  };


  const checkIfBatchAlreadyExists = (product_code, batch_code) => {
    return invoiceItemsList.some(
      e => e.product_code === product_code && e.batch_code === batch_code
    );
  };


  const updateBatch = useCallback((product_code, index, data) => {
    console.log({
      batches,
    });
    setBatches(
      produce(draft => {
        let batch = draft.find(i => i.product_code === product_code);
        console.log("bbb", index, batch.batches, draft, batch);
        batch.batches[index].stock = data;
      })
    );
  }, []);

  const updateTotal = useCallback((itemId, data) => {
    setInvoiceItemsList(
      produce(draft => {
        for (let item of draft) {
          const price = Number(item?.selected_batch?.price) || 0;
          const qty = Number(item.qty) || 0;
          const discountAmount = Number(item.discount) || 0;
          const taxPercentage = Number(item.tax) || 0;

          // Calculate basic amount (price × quantity)
          item.basic_amount = price * qty;

          // Calculate amount after discount
          const amountAfterDiscount = item.basic_amount - discountAmount;

          // Calculate tax (if needed)
          const denominator = 100 + taxPercentage;
          const tax = (amountAfterDiscount - (amountAfterDiscount / denominator) * 100).toFixed(2);

          item.tax_total = Number(tax);
          item.total = amountAfterDiscount;

          console.log("💰 Amount Calculation:", {
            product: item.product_name,
            price: price,
            qty: qty,
            basic_amount: item.basic_amount,
            discount: discountAmount,
            total: item.total,
            pricrs: item.selected_batch.price,
            discounts: item.discount
          });
        }
      })
    );
  }, []);

  const resetInvoiceItem = useCallback(itemId => {
    setInvoiceItemsList(draft => {
      const item = draft.find(item => item.id === itemId);
      item.entered_qty = 0;
      item.qty = 0;
      item.total = 0;
      item.tax_total = 0;
    });
  }, []);

  const updateInvoiceItem = useCallback((type, itemId, data) => {
    // Function for updating static values in invoice items which doesn't require any calculations
    setInvoiceItemsList(draft => {
      const item = draft.find(item => item.id === itemId);
      console.log(item);
      switch (type) {
        case "discount":
          item.discount = data;
          break;
        case "free_samples":
          item.free_samples = data;
          break;
        default:
          break;
      }
    });
  }, []);

  const getTotal = (type, inVoiceItems, appliedCoupon, packageCharge) => {
    let getAppliedcoupon = appliedCoupon ? appliedCoupon : couponApplied;
    let getPackingCharge = Number(packageCharge ? packageCharge : packingCharge);

    let total_amount = 0;
    let tax_total = 0;
    let boxes = 0;
    let pieces = 0;
    let free_samples = 0;
    let discount = 0;
    let subtotal = 0;
    let coupon = 0;
    let packing_charge = packingCharge;

    // Calculate base totals
    for (let item of (inVoiceItems ? inVoiceItems : invoiceItemsList)) {
      if (!item.deleted) {
        total_amount += item.total || 0;
        tax_total += item.tax_total || 0;
        boxes += item.box || 0;
        pieces += item.pieces || 0;
        free_samples += item.free_samples || 0;
        discount += item.discount || 0;
        subtotal += item.basic_amount || 0;
      }
    }

    // Add packing charge
    total_amount = total_amount + getPackingCharge;
    const totalBeforeCoupon = total_amount;
    // ✅ Check which type of coupon is applied
    if (selectedReferralCoupon) {
      // ✅ REFERRAL COUPON LOGIC
      const cutoffAmount = Number(selectedReferralCoupon.min_purchase || selectedReferralCoupon.cutoff_amount || 0);

      if (totalBeforeCoupon >= cutoffAmount) {
        // Calculate referral coupon discount
        if (selectedReferralCoupon.discount_type === 'percentage') {
          coupon = (totalBeforeCoupon * selectedReferralCoupon.discount_amount) / 100;
        } else {
          coupon = Number(selectedReferralCoupon.discount_amount);
        }

        // Cap discount at total amount
        if (coupon > totalBeforeCoupon) {
          coupon = totalBeforeCoupon;
        }
      }
    } else if (getAppliedcoupon?.id) {
      // ✅ REGULAR/YEARLY COUPON LOGIC
      const isYearlyCoupon = getAppliedcoupon.coupon_type === "Yearly" ||
        getAppliedcoupon.coupon_code === yearlyCouponCode;

      const cutoffAmount = Number(getAppliedcoupon.cutoff_amount || 0);

      let meetsCutoff = false;

      if (isYearlyCoupon) {
        // Yearly coupons: Must be STRICTLY GREATER THAN
        meetsCutoff = totalBeforeCoupon > cutoffAmount;
      } else {
        // Regular coupons: Must be GREATER THAN OR EQUAL TO
        meetsCutoff = totalBeforeCoupon >= cutoffAmount;
      }

      if (meetsCutoff) {
        // Calculate coupon value
        if (getAppliedcoupon.coupon_type === "flat") {
          coupon = Number(totalBeforeCoupon * (getAppliedcoupon.value / 100));
        } else {
          coupon = Number(getAppliedcoupon.value);
        }

        // Cap discount at total amount
        if (coupon > totalBeforeCoupon) {
          coupon = totalBeforeCoupon;
        }
      }
    }

    coupon = isNaN(coupon) ? 0 : Number(coupon);
    // Final total with coupon deduction
    total_amount = total_amount - coupon;

    switch (type) {
      case "packing_charge":
        return packing_charge;
      case "amount":
        return total_amount;
      case "subtotal":
        return subtotal - tax_total;
      case "discount":
        return discount;
      case "coupon":
        return coupon;
      case "tax":
        return tax_total;
      case "boxes":
        return boxes;
      case "pieces":
        return pieces;
      case "free_samples":
        return free_samples;
      case "amount_before_coupon":
        return totalBeforeCoupon;

      default:
        return 0;
    }
  };

  const updateInvoiceItemData = (batchCode, qty, stock) => {
    setInvoiceItemsList(
      produce(draft => {
        let product = draft.find(e => e.batch_code === batchCode);
        console.log("Product changing");
        product.entered_qty += +qty;
        product.qty += +qty;
        product.selected_batch.stock = +stock;
      })
    );
  };

  const updateDiscount = (productCode, batchCode, discountPercentage) => {
    console.log({
      productCode,
      batchCode,
      discountPercentage,
    });
    setInvoiceItemsList(
      produce(draft => {
        let product = draft.find(e => e.product_code === productCode && e.batch_code === batchCode);
        product.discountPercentage = +discountPercentage;

        const discount = product.basic_amount * (+discountPercentage / 100);
        product.discount = +discount.toFixed(2);

        console.log(discount);

        // product.selected_batch.stock = +stock;
      })
    );
  };

  const applyNetDiscount = () => {
    for (let item of invoiceItemsList) {
      updateDiscount(item.product_code, item.batch_code, netDiscount);
    }
    updateTotal();
  };
  const applyCoupon = (set) => {
    // ❌ Remove coupon
    if (!set) {
      setCouponApplied({});
      setSelectedReferralCoupon(null);
      setReferralCouponApplied(false);
      setCouponCode({ coupon_code: "" });
      setReferralCouponCode("");
      showSuccessToast({
        title: "Coupon Removed",
        message: "Coupon has been removed",
      });
      updateTotal();
      return;
    }

    // ❌ No coupon code entered
    if (!couponCode?.coupon_code) {
      showErrorToast({
        title: "Error",
        message: "Please enter a coupon code",
      });
      return;
    }

    // 🔍 Find coupon
    const coupon = availableCoupons.find(
      value => value.coupon_code === couponCode.coupon_code
    ) || null;

    // If not found in available coupons
    if (!coupon) {
      // Check if it's the customer's yearly coupon
      if (couponCode.coupon_code === yearlyCouponCode) {
        if (!customerQualifiesForYearlyCoupon) {
          showErrorToast({
            title: "Not Eligible",
            message: customerYearlyCouponStatus?.month_count
              ? `Customer needs ${11 - customerYearlyCouponStatus.month_count} more months to qualify`
              : "Customer not eligible for yearly coupon"
          });
          setCouponCode({ coupon_code: "" });
          return;
        }

        // ✅ IMPORTANT: Get cutoff amount from yearly coupon status
        const yearlyCouponCutoff = customerYearlyCouponStatus?.cutt_off_amount ||
          customerYearlyCouponStatus?.cutoff_amount ||
          0;

        // Create a temporary coupon object for yearly coupon
        const yearlyCouponObj = {
          id: `yearly_${customerId}`,
          coupon_code: yearlyCouponCode,
          coupon_name: "Yearly Reward Coupon",
          coupon_type: "flat",
          business_type: "yearly",
          value: customerYearlyCouponStatus?.coupon_amount || 0,
          cutoff_amount: yearlyCouponCutoff, // ✅ Set actual cutoff amount
          required_purchase_amount: yearlyCouponCutoff + 100,
          active: true,
          yearly_coupon_id: customerYearlyCouponStatus?.id,
          is_yearly: true
        };

        // Validate minimum purchase (STRICTLY GREATER THAN for yearly coupons)
        validateAndApplyCoupon(yearlyCouponObj);
        return;
      }
      // 🔍 Check 2: Is it a referral coupon?
      const referralCoupon = referralCoupons.find(c =>
        c.code.toLowerCase() === couponCode.coupon_code.toLowerCase() ||
        c.coupon_code.toLowerCase() === couponCode.coupon_code.toLowerCase()
      );

      if (referralCoupon) {
        // Apply referral coupon logic
        console.log("Found referral coupon:", referralCoupon);

        // Check minimum purchase requirement
        const totalBeforeCoupon = getTotal("amount_before_coupon");
        const minPurchase = referralCoupon.min_purchase || referralCoupon.cutoff_amount || 0;

        if (totalBeforeCoupon < minPurchase) {
          showErrorToast({
            title: "Minimum Purchase Required",
            message: `This referral coupon requires minimum purchase of ₹${minPurchase}`
          });
          setCouponCode({ coupon_code: "" });
          return;
        }

        // Check expiry date
        if (referralCoupon.expiry_date) {
          const currentDate = new Date();
          const expiryDate = new Date(referralCoupon.expiry_date);
          if (currentDate > expiryDate) {
            showErrorToast({
              title: "Coupon Expired",
              message: "This referral coupon has expired"
            });
            setCouponCode({ coupon_code: "" });
            return;
          }
        }

        // Check if already used
        if (referralCoupon.used === true || referralCoupon.active === false) {
          showErrorToast({
            title: "Coupon Used",
            message: "This referral coupon has already been used"
          });
          setCouponCode({ coupon_code: "" });
          return;
        }

        // All validations passed - apply referral coupon
        setSelectedReferralCoupon(referralCoupon);
        setReferralCouponApplied(true);
        setReferralCouponCode(referralCoupon.code || referralCoupon.coupon_code);

        // Clear regular coupon
        setCouponApplied({});

        showSuccessToast({
          title: "Success",
          message: `Referral coupon ${referralCoupon.code || referralCoupon.coupon_code} applied successfully!`
        });

        updateTotal();
        return;
      }
      showErrorToast({
        title: "Invalid Coupon",
        message: "Coupon not found or not available",
      });
      setCouponCode({ coupon_code: "" });
      return;
    }

    // Validate and apply the found coupon
    validateAndApplyCoupon(coupon);
  };

  // Updated validateAndApplyCoupon function
  const validateAndApplyCoupon = (coupon) => {
    // 💰 Get current total BEFORE coupon
    const totalAmountBeforeCoupon = getTotal("amount_before_coupon");

    // ✅ CHECK 1: Determine if this is a yearly coupon
    const isYearlyCoupon = coupon.coupon_type === "Yearly" ||
      coupon.coupon_code === yearlyCouponCode ||
      (coupon.coupon_name && coupon.coupon_name.includes("Yearly")) ||
      coupon.business_type === "yearly";
    const isReferralCoupon = coupon.business_type === "referral" ||
      (coupon.code && referralCoupons.some(rc => rc.code === coupon.code));
    // ✅ CHECK 2: Minimum purchase amount validation
    const cutoffAmount = Number(coupon.cutoff_amount || 0);

    if (cutoffAmount > 0) {
      // ✅ FIX: Different logic for yearly vs regular coupons
      let meetsCutoff = false;
      let errorMessage = "";

      if (isYearlyCoupon) {
        /// ✅ Yearly coupon: Must be STRICTLY GREATER THAN cutoff (>) plus 100 rupees
        const yearlyCutoffWithBuffer = cutoffAmount + 100; // Add 100 rupees requirement
        meetsCutoff = totalAmountBeforeCoupon > yearlyCutoffWithBuffer;
        errorMessage = `Purchase amount must be GREATER THAN ₹${yearlyCutoffWithBuffer.toFixed(2)}`;
      } else {
        // ✅ Regular coupon: Must be GREATER THAN OR EQUAL TO cutoff (>=)
        meetsCutoff = totalAmountBeforeCoupon >= cutoffAmount;
        errorMessage = `Minimum purchase amount is ₹${cutoffAmount.toFixed(2)}`;
      }

      if (!meetsCutoff) {
        // Calculate how much more is needed
        let shortBy = 0;
        if (isYearlyCoupon) {
          // For yearly coupons with 100 rupees buffer
          const yearlyCutoffWithBuffer = cutoffAmount + 100;
          shortBy = Math.max(0.01, (yearlyCutoffWithBuffer - totalAmountBeforeCoupon + 0.01));
        } else {
          // For regular coupons: Need at least (cutoffAmount - totalAmountBeforeCoupon)
          shortBy = Math.max(0, cutoffAmount - totalAmountBeforeCoupon);
        }

        showErrorToast({
          title: "Coupon Cannot Be Applied",
          message: `${errorMessage}. Need ₹${shortBy.toFixed(2)} more. Current: ₹${totalAmountBeforeCoupon.toFixed(2)}`,
        });
        setCouponCode({ coupon_code: "" });
        setCouponApplied({});
        updateTotal();
        return;
      }
    }

    // ✅ CHECK 3: For yearly coupons, validate customer eligibility
    if (isYearlyCoupon) {
      if (!customerQualifiesForYearlyCoupon) {
        showErrorToast({
          title: "Not Eligible",
          message: customerYearlyCouponStatus?.month_count
            ? `Customer needs ${11 - customerYearlyCouponStatus.month_count} more months to qualify`
            : "Customer not eligible for yearly coupon"
        });
        setCouponCode({ coupon_code: "" });
        setCouponApplied({});
        return;
      }

      // Additional validation for yearly coupon
      if (customerYearlyCouponStatus?.active === false) {
        showErrorToast({
          title: "Coupon Inactive",
          message: "This yearly coupon is no longer active"
        });
        setCouponCode({ coupon_code: "" });
        setCouponApplied({});
        return;
      }
    }

    // ✅ CHECK 4: Coupon value should not exceed total amount
    let couponValue = 0;

    if (coupon.coupon_type === "flat") {
      // For percentage coupons
      couponValue = (totalAmountBeforeCoupon * (coupon.value / 100));
    } else {
      // For fixed amount coupons
      couponValue = Number(coupon.value);
    }

    // Ensure coupon value doesn't exceed total amount
    if (couponValue > totalAmountBeforeCoupon) {
      showErrorToast({
        title: "Coupon Not Applied",
        message: `Coupon value (₹${couponValue.toFixed(2)}) exceeds total amount (₹${totalAmountBeforeCoupon.toFixed(2)})`,
      });
      setCouponCode({ coupon_code: "" });
      setCouponApplied({});
      return;
    }
    // ✅ All validations passed - Apply coupon
    if (isReferralCoupon) {
      // For referral coupons
      setSelectedReferralCoupon(coupon);
      setReferralCouponApplied(true);
      setReferralCouponCode(coupon.code || coupon.coupon_code);
      setCouponApplied({}); // Clear regular coupon
    } else {
      // For regular/yearly coupons
      setCouponApplied(coupon);
      setSelectedReferralCoupon(null); // Clear referral coupon
      setReferralCouponApplied(false);
      setReferralCouponCode("");
    }
    // ✅ CHECK 5: For yearly coupons, check if it's already been used
    if (isYearlyCoupon && couponApplied?.coupon_code === yearlyCouponCode) {
      showErrorToast({
        title: "Already Applied",
        message: "Yearly coupon is already applied to this invoice"
      });
      return;
    }

    // ✅ All validations passed - Apply coupon
    setCouponApplied(coupon);

    showSuccessToast({
      title: "Coupon Applied",
      message: `Coupon "${coupon.coupon_code}" applied successfully!`,
    });

    // 🔄 Recalculate totals
    updateTotal();
  };
  const filterAvailableCoupons = () => {
    if (!coupons || coupons.length === 0) {
      setAvailableCoupons([]);
      return;
    }

    const filteredCoupons = coupons.filter(coupon => {
      // Check if this is a yearly coupon
      const isYearlyCoupon = coupon.coupon_code === yearlyCouponCode ||
        coupon.coupon_type === "Yearly" ||
        (coupon.coupon_name && coupon.coupon_name.includes("Yearly"));

      if (isYearlyCoupon) {
        // Only include if customer qualifies
        return customerQualifiesForYearlyCoupon;
      }

      // Include all non-yearly coupons
      return true;
    });

    setAvailableCoupons(filteredCoupons);

    // If customer qualifies for yearly coupon but it's not in the filtered list,
    // we need to add it manually
    if (customerQualifiesForYearlyCoupon && yearlyCouponCode) {
      const yearlyCouponExists = filteredCoupons.some(c => c.coupon_code === yearlyCouponCode);

      if (!yearlyCouponExists) {
        // Get cutoff amount from customer's yearly coupon status
        const yearlyCouponCutoff = customerYearlyCouponStatus?.cutt_off_amount ||
          customerYearlyCouponStatus?.cutoff_amount ||
          0;

        // Create a temporary yearly coupon object WITH CORRECT CUTOFF
        const yearlyCoupon = {
          id: `yearly_${customerId}`,
          coupon_code: yearlyCouponCode,
          coupon_name: "Yearly Reward Coupon",
          coupon_type: "Yearly",
          value: customerYearlyCouponStatus?.coupon_amount || 0,
          cutoff_amount: yearlyCouponCutoff, // ✅ Important: Set actual cutoff
          required_purchase_amount: yearlyCouponCutoff + 100, // ✅ Add required purchase amount
          active: true
        };

        setAvailableCoupons([yearlyCoupon, ...filteredCoupons]);
      }
    }
  };


  const handleBatches = (productCode, batchCode, total_stock_needed, selectedIndex) => {
    setBatches(
      produce(draft => {
        const product = invoiceItemsList.find(e => e.product_code === productCode);
        const batches = draft.find(e => e.product_code === productCode).batches;

        let fulfilled_stock = 0;
        const selected_batches = [];

        const is_batch_already_present = code =>
          invoiceItemsList.some(e => e.batch_code === code);

        // 1️⃣ consume DOWNWARDS (after selectedIndex)
        for (let i = selectedIndex + 1; i < batches.length; i++) {
          if (fulfilled_stock >= total_stock_needed) break;

          let batch = batches[i];
          let needed = total_stock_needed - fulfilled_stock;
          if (batch.stock <= 0) continue;

          let take = Math.min(batch.stock, needed);
          fulfilled_stock += take;
          batch.stock -= take;

          if (is_batch_already_present(batch.batch_code)) {
            updateInvoiceItemData(batch.batch_code, take, batch.stock);
          } else {
            selected_batches.push({
              ...product,
              product_name: product.product_name, // Ensure product name is included
              product_code: product.product_code,
              code: product.code,
              tax: product.tax,
              units: product.units,
              selected_unit: product.units,
              precision: isDecimalUnit(product.units) ? 3 : 0,
              allowDecimal: isDecimalUnit(product.units),
              deleted: false,
              id: null,
              batch_code: batch.batch_code,
              selected_batch: { ...batch },
              qty: take,
              entered_qty: take,
            });
          }
        }

        // 2️⃣ if still needed, consume UPWARDS (before selectedIndex)
        if (fulfilled_stock < total_stock_needed) {
          for (let i = selectedIndex - 1; i >= 0; i--) {
            if (fulfilled_stock >= total_stock_needed) break;

            let batch = batches[i];
            let needed = total_stock_needed - fulfilled_stock;
            if (batch.stock <= 0) continue;

            let take = Math.min(batch.stock, needed);
            fulfilled_stock += take;
            batch.stock -= take;

            if (is_batch_already_present(batch.batch_code)) {
              updateInvoiceItemData(batch.batch_code, take, batch.stock);
            } else {
              selected_batches.push({
                ...product,
                deleted: false,
                id: null,
                batch_code: batch.batch_code,
                selected_batch: { ...batch },
                qty: take,
                entered_qty: take,
              });
            }
          }
        }

        // 3️⃣ finally push newly selected batches
        selected_batches.forEach(i => {
          addInvoiceItem(i);
          updateTotal();
        });
      })
    );
  };


  // const check_item_duplication = (productCode, batchCode) => {
  //   const already_exists = invoiceItemsList.find(
  //     e => e.product_code === productCode && e.batch_code === batchCode
  //   );
  //   return !!already_exists;
  // };

  const addInvoiceItem = useCallback(invoiceItem => {
    setInvoiceItemsList(
      produce(draft => {
        //invoiceItem.deleted = false;
        draft.unshift(invoiceItem);
      })
    );
  }, []);

  //   const constructInvoiceItem = (itemToAdd) => {
  //     return {
  //         ...itemToAdd,
  //         selected_unit: itemToAdd.units, // 🔥 itemToAdd-இல் இருந்து Units-ஐ எடுக்கிறோம்
  //         qty: 0,
  //     };
  // };
  // const totalItems = invoiceItemsList.length;
  // const totalAmount = invoiceItemsList.reduce((acc, i) => acc + (i.total || 0), 0);
  //   const totalPcs = invoiceItemsList
  //     ?.filter(item => !isDecimalUnit(item.selected_unit))
  //     .reduce((sum, item) => sum + (parseFloat(item.qty) || 0), 0);

  //   const totalKgs = invoiceItemsList
  //     ?.filter(item => isDecimalUnit(item.selected_unit))
  //     .reduce((sum, item) => sum + (parseFloat(item.qty) || 0), 0);

  // const handleAddInvoiceItem = (productCode, batchCode = null, isScanner = false) => {
  //     const itemToAdd = productsList.find(e => e.code === productCode);
  //     if (!itemToAdd) {
  //         showErrorToast({ title: "Error", message: "Invalid product. Please select from list." });
  //         return;
  //     }

  //     let batchToSelect = null;

  //     // User oru batchCode kuduthirundha, adha select pannurom
  //     if (batchCode) {
  //         batchToSelect = itemToAdd.batches.find(b => b.batch_code.toLowerCase() === batchCode.toLowerCase());
  //         if (!batchToSelect) {
  //             showErrorToast({ title: "Error", message: `Batch '${batchCode}' not found.` });
  //             return;
  //         }
  //     } else {
  //         // Illana, default ah முதல் batch ah eduthukurom (idhu unga palaya functionality)
  //         batchToSelect = itemToAdd.batches[0];
  //     }

  //     if (!batchToSelect) {
  //         showErrorToast({ title: "Error", message: "Product has no available stock." });
  //         return;
  //     }


  //     const existingItem = invoiceItemsList.find(
  //     e => e.product_code === itemToAdd.product_code && e.batch_code === batchToSelect.batch_code
  //   );

  //   if (existingItem) {
  //   if (isScanner) {
  //     const newQty = (parseFloat(existingItem.entered_qty) || 0) + 1;
  //     if (newQty > existingItem.selected_batch.stock) {
  //         showErrorToast({
  //           title: "Insufficient Stock",
  //           message: `Only ${existingItem.selected_batch.stock} units available`
  //         });
  //         setTimeout(() => {
  //       document.getElementById("temp_qty_input")?.focus();
  //       document.getElementById("temp_qty_input")?.select();
  //     }, 100);
  //         return;
  //       }
  //     setInvoiceItemsList(
  //       produce(draft => {
  //         const item = draft.find(
  //           x =>
  //             x.product_code === itemToAdd.product_code &&
  //             x.batch_code === batchToSelect.batch_code
  //         );
  //         if (item) {
  //           item.entered_qty = newQty;
  //           item.qty = newQty;
  //         }
  //       })
  //     );
  //     updateTotal();
  //     return;
  //   } else {
  //     showErrorToast({
  //       title: "Error",
  //       message: "This product and batch combination is already in the list.",
  //     });

  //     // 🔒 Prevent Select box from stealing focus again
  //     setLockFocus(true);

  //     // Wait until React re-renders (invoice table already visible)
  //     setTimeout(() => {
  //       const qtyInputWrapper = document.getElementById(
  //         `qty_input_${itemToAdd.code}_${batchToSelect.batch_code}`
  //       );

  //       if (qtyInputWrapper) {
  //         // Mantine renders <div id="..."><input /></div>
  //         const inputEl =
  //           qtyInputWrapper.querySelector("input") || qtyInputWrapper;
  //         inputEl.focus();
  //         inputEl.select?.();
  //       }

  //       // 🔓 Release lock slightly later to avoid race with Mantine Select
  //       setTimeout(() => setLockFocus(false), 500);
  //     }, 250);

  //     return;
  //   }
  // }




  // //     if (check_item_duplication(itemToAdd.product_code, batchToSelect.batch_code)) {
  // //   showErrorToast({ title: "Error", message: "This product and batch combination is already in the list." });
  // //   return;
  // // }

  //     // IMPORTANT: Inga namba constructInvoiceItem use pannama, batchToSelect vechu manual ah newItem create panrom
  //     const newItem = {
  //         ...itemToAdd,
  //         selected_unit: itemToAdd.units,
  //         precision: isDecimalUnit(itemToAdd.units) ? 3 : 0,   // <-- added
  //         allowDecimal: isDecimalUnit(itemToAdd.units),
  //         selected_batch: batchToSelect,
  //         batch_code: batchToSelect.batch_code,
  //         qty: 0,
  //         entered_qty: 0,
  //         total: 0,
  //         basic_amount: 0,
  //         tax_total: 0,
  //         discount: 0,
  //         discountPercentage: 0,
  //         deleted: false,
  //         id: null,
  //     };
  //     addInvoiceItem(newItem);

  //     // Qty input-ku focus panna idhu thevai
  //     setSelectValue(productCode);
  //     setFocus(true);
  //   };

  const deleteInvoiceItem = useCallback((uniqueId) => {
    console.log("Invoice Items List Before Deletion:", invoiceItemsList, uniqueId);
    // Find the item first to get the correct product_code and batch_code
    const itemToDelete = invoiceItemsList.find(item =>
      `${item.product_code}_${item.batch_code}` === uniqueId
    );

    if (!itemToDelete) {
      console.error("Item not found for deletion:", uniqueId);
      return;
    }

    const product_code = itemToDelete.product_code;
    const batch_code = itemToDelete.batch_code;
    const itemId = itemToDelete.id;

    console.log("Delete function :: Product Code:", product_code, "Batch Code:", batch_code);
    setInvoiceItemsList(
      produce((draft) => {
        const index = draft.findIndex((item) =>
          item.product_code === product_code && item.batch_code === batch_code
        );

        if (index === -1) {
          console.error("Item not found in draft");
          return;
        }

        // Remove the item from the invoice list
        draft.splice(index, 1);
      })
    );

    // Store deleted item IDs separately
    if (itemId) {
      console.log("Deleting Invoice Item ID:", itemId);
      setDeletedItems(
        produce((deletedDraft) => {
          deletedDraft.push(itemId);
        })
      );
    }

    // Now update the batches state safely
    setBatches(
      produce((batchDraft) => {
        const product = batchDraft.find((e) => e.product_code === product_code);
        if (!product) return; // Prevent errors if product not found

        console.log("Found Product for Reset:", current(product));

        const batchIndex = product.batches.findIndex((x) => x.batch_code === batch_code);
        if (batchIndex !== -1) {
          product.batches[batchIndex].stock = product.batches[batchIndex].total_stock;
        }
      })
    );


    updateTotal();
  }, [invoiceItemsList]);

  const deliverInvoice = async id => {
    if (id) {
      await invoice_api.deliver_invoice(id).then(res => {
        console.log(res.data);
        if (res.data.success) {
          showSuccessToast({
            title: "Success",
            message: "Item marked as delivered",
          });
        } else {
          showErrorToast({
            title: "Error",
            message: res.data.message,
          });
        }
      });
    }
  };

  const submitInvoice = useMutation({
    mutationFn: data => invoice_api.submit_invoice(data),
    onSuccess: data => {
      // console.log('qqq-1234', data, data.data.data);
      if (data.data.success) {
        setInvoicesId(data.data.data);
        setInvoicesData(data.data.data.data);
        // console.log('qqq-1', invoicesData);
        console.log(data.data);
        setPaymentReceiptData({
          invoice: data.data.data.id,
          invoice_id: data.data.data.invoice_id,
          total: +getTotal("amount").toFixed(2),
        });
        showSuccessToast({ title: "Success", message: data.data?.message });

        // Clear exchange state upon successful save
        sessionStorage.removeItem("exchangeRefundCredit");
        sessionStorage.removeItem("originalInvoiceId");
        sessionStorage.removeItem("originalInvoiceNo");
        setExchangeRefundCredit(0);
        setOriginalInvoiceNo("");
        setOriginalInvoiceId(null);

        if (window.runStockRef && data?.data?.data?.id) {
          const savedInvoiceItems = JSON.parse(sessionStorage.getItem("invoiceItems")) || [];

          const stockRefItems = savedInvoiceItems.map(item => ({
            batch_id: item?.selected_batch?.id,
            qty: item?.qty
          }));

          // API CALL TO SAVE STOCK REFERENCE
          invoice_api.saveStockReference({
            invoice_id: data.data.data.id,
            items: stockRefItems,
            counter: counterId,
          }).then(sr => {
            console.log("Stock Reference Saved:", sr);
          }).catch(err => {
            console.log("Stock Ref Error", err);
          });
        }
        if (payAndPrintBill) {
          setPaymentReceiptFormVisible(true);
          deliverInvoice(data.data.data.id)
        }

        if (!payAndPrintBill) {
          navigate("/invoices");
        }
      } else {
        showErrorToast({ title: "Warning", message: data.data?.message });
      }
    },
    onError: () => {
      showErrorToast({ title: "Error", message: "Error submitting invoice." });
    },
  });

  const editInvoice = useMutation({
    mutationFn: data => invoice_api.edit_invoice(data),
    onSuccess: data => {
      console.log('qqq-1234', data, data.data.data);
      if (data.data.success) {
        setInvoicesId(data.data);
        setInvoicesData(data.data.data);
        setPaymentReceiptData({
          invoice: data.data.data.id,
          invoice_id: data.data.data.invoice_id,
          total: +getTotal("amount").toFixed(2),
        });
        showSuccessToast({ title: "Success", message: data.data?.message });

        // Clear exchange state upon successful save
        sessionStorage.removeItem("exchangeRefundCredit");
        sessionStorage.removeItem("originalInvoiceId");
        sessionStorage.removeItem("originalInvoiceNo");
        setExchangeRefundCredit(0);
        setOriginalInvoiceNo("");
        setOriginalInvoiceId(null);
        // if (payAndPrintBill) {
        //   printInvoice(data.data.data);
        // }

        if (payAndPrintBill) {
          setPaymentReceiptFormVisible(true);
          deliverInvoice(data.data.data.id)
        }

        if (!payAndPrintBill) {
          navigate("/invoices");
        }
      } else {
        showErrorToast({ title: "Warning", message: data.data?.message });
      }
    },
    onError: () => {
      showErrorToast({ title: "Error", message: "Error editting invoice." });
    },
  });
  const printInvoice = data => {
    console.log('qqq-123', data);
    const item = data.invoice_item.map(e => {
      return `<tr style="border-bottom: 1px dashed #ccc;">
            <td style="text-align: left; padding: 6px 0 6px 10px; vertical-align: top; white-space: normal; word-break: break-word;">
              <span style="font-weight: bold; font-size: 13px; color: #000; display: block;">${e.product}</span>
              <span style="font-size: 9.5px; color: #555; display: block; margin-top: 2px; white-space: nowrap;">
                ${e.varientSlug ? `${e.varientSlug} | ` : ""}<span style="font-size: 11px; font-weight: bold; color: #000;">BN: ${e.batch_no}</span> | Tax: ${e.tax}%
              </span>
            </td>
            <td style="text-align: right; padding: 6px 0; vertical-align: top; font-size: 13px; font-weight: bold;">
              ${e.qty}
            </td>
            <td style="text-align: right; padding: 6px 0; vertical-align: top; font-size: 13px;">
              ${e.rate.toFixed(2)}<br/>
              <span style="font-size: 10px; color: #777;">MRP: ${e.mrp.toFixed(2)}</span>
            </td>
            <td style="text-align: right; padding: 6px 10px 6px 0; vertical-align: top; font-size: 13px; font-weight: bold;">
              ${e.amount.toFixed(2)}<br/>
              <span style="font-size: 10px; color: #777; font-weight: normal;">Disc: ${e.discount}%</span>
            </td>
        </tr>`;
    });

    const qty = data.invoice_item.reduce((accumulator, currentValue) => {
      return accumulator + currentValue.qty;
    }, 0);
    const items = item.join("");
    const printWindow = window.open("", "", "width=600,height=600");
    printWindow.document.open();
    printWindow.document.write(printTemplate(data, items, moment, qty));
    printWindow.document.close();
    printWindow.print();
    printWindow.close();
    navigate("/invoices");
  };

  const saveInvoice = (type, isF6Flow = false) => {
    const savedInvoiceItems = JSON.parse(sessionStorage.getItem("invoiceItems")) || [];
    const savedCustomerId = sessionStorage.getItem("customerId") || "";
    const savedCouponApplied = JSON.parse(sessionStorage.getItem("couponApplied")) || {};
    const savedPackingCharge = sessionStorage.getItem("packingCharge") || 0;
    const savedOriginalInvoiceId = sessionStorage.getItem("originalInvoiceId") || null;

    setInvoiceItemsList(savedInvoiceItems);
    setCustomerId(savedCustomerId);
    setCouponApplied(savedCouponApplied);
    setPackingCharge(savedPackingCharge);

    let payload = {};

    // Add referral coupon to payload if applied
    if (selectedReferralCoupon) {
      payload.referral_coupon_id = selectedReferralCoupon.id;
      payload.referral_coupon_code = selectedReferralCoupon.code || selectedReferralCoupon.coupon_code;
      payload.referral_discount_amount = getTotal("referral_discount", savedInvoiceItems, {}, savedPackingCharge, selectedReferralCoupon);
    }

    if (savedCustomerId && savedInvoiceItems?.length > 0 && savedInvoiceItems.some(item => item.qty === 0)) {
      showErrorToast({ title: "Error", message: "One or more items have qty set to 0" });
      return;
    }

    // ✅ Check if there's a valid coupon
    const hasValidCoupon = savedCouponApplied && (savedCouponApplied.id || savedCouponApplied.coupon_code);

    // ✅ Check if it's a yearly coupon
    const isYearlyCoupon = savedCouponApplied?.business_type === "yearly" ||
      savedCouponApplied?.coupon_code === yearlyCouponCode ||
      savedCouponApplied?.is_customer_specific === true;

    // ✅ Check if there's a valid referral coupon
    const hasValidReferralCoupon = selectedReferralCoupon && selectedReferralCoupon.id;

    let coupon = 0;
    let couponId = null;
    let couponBusinessType = null;
    let referralCouponId = null;
    let referralCouponCode = null;
    let yearlyCouponId = null;

    // ✅ Calculate coupon amount (for both F5 and display purposes)
    if (hasValidCoupon) {
      const totalWithoutCoupon = getTotal("amount", savedInvoiceItems, {}, savedPackingCharge);

      if (savedCouponApplied?.coupon_type === "flat") {
        coupon = Number(totalWithoutCoupon * (savedCouponApplied?.value / 100)).toFixed(2);
      } else {
        coupon = Number(savedCouponApplied?.value).toFixed(2);
      }
      coupon = isNaN(coupon) ? 0 : parseFloat(coupon).toFixed(2);

      // Handle coupon ID based on type
      if (isYearlyCoupon) {
        // For yearly coupons, use the actual yearly coupon ID from customerYearlyCouponStatus
        couponId = null; // Yearly coupons might not have a regular coupon ID
        yearlyCouponId = customerYearlyCouponStatus?.id || null;
        couponBusinessType = "yearly";
      } else {
        // For regular coupons
        couponId = savedCouponApplied.id;
        couponBusinessType = savedCouponApplied.business_type || "regular";
      }
    }

    // ✅ Handle REFERRAL coupon
    if (hasValidReferralCoupon) {
      referralCouponId = selectedReferralCoupon.id;
      referralCouponCode = selectedReferralCoupon.code || selectedReferralCoupon.coupon_code;
      couponBusinessType = "referral";

      // ✅ ADD THIS: Calculate referral coupon amount
      const totalWithoutCoupon = getTotal("amount", savedInvoiceItems, {}, savedPackingCharge);

      if (selectedReferralCoupon?.coupon_type === "flat" ||
        selectedReferralCoupon?.coupon_type === "Percentage" ||
        selectedReferralCoupon?.discount_type === 'percentage') {
        coupon = Number(totalWithoutCoupon * (selectedReferralCoupon?.value / 100)).toFixed(2);
      } else {
        coupon = Number(selectedReferralCoupon?.value ||
          selectedReferralCoupon?.discount_amount || 0).toFixed(2);
      }

      coupon = isNaN(coupon) ? 0 : parseFloat(coupon).toFixed(2);

    }

    const invoice_items = savedInvoiceItems.map(e => {
      return {
        id: e.id,
        counter_stock_id: e.counter_stock_id,
        counter_stock_batch_id: e.selected_batch.id,
        qty: e.qty,
        rate: e?.selected_batch.price,
        amount: e.total,
        discount: e.discountPercentage,
        discount_amount: e.discount,
        tax: e.tax,
        tax_amount: e.tax_total,
      };
    });

    console.log({ invoice_items });

    // ✅ Calculate base totals (without coupon for F6, with coupon for F5)
    const subtotal = +getTotal("subtotal", savedInvoiceItems, {}, savedPackingCharge);
    const tax_total = +getTotal("tax", savedInvoiceItems, {}, savedPackingCharge).toFixed(2);
    const discount_total = +getTotal("discount", savedInvoiceItems, {}, savedPackingCharge);

    // Calculate total based on flow
    let total = 0;
    if (isF6Flow) {
      // F6 FLOW: Total WITHOUT any coupons
      total = +getTotal("amount", savedInvoiceItems, {}, savedPackingCharge);
    } else {
      // F5 FLOW: Total WITH appropriate coupon
      if (hasValidCoupon) {
        // Apply regular/yearly coupon discount
        total = +getTotal("amount", savedInvoiceItems, savedCouponApplied, savedPackingCharge);
      } else {
        // No coupon
        total = +getTotal("amount", savedInvoiceItems, {}, savedPackingCharge);
      }
    }

    // Apply symmetric rounding (round half away from zero) to match UI
    total = Math.sign(total) * Math.round(Math.abs(total));

    // Determine the final business type for invoice
    let finalBusinessType = null;
    if (!isF6Flow) {
      if (isYearlyCoupon) {
        finalBusinessType = "yearly";
      } else if (hasValidReferralCoupon) {
        finalBusinessType = "referral";
      } else if (hasValidCoupon) {
        finalBusinessType = savedCouponApplied?.business_type || "regular";
      }
    }

    payload = {
      invoice: {
        sub_total: subtotal,
        tax_total: tax_total,
        discount_total: discount_total,
        total: total,
        // coupon_business_type: finalBusinessType,
      },
      customer_id: savedCustomerId,
      invoice_item: invoice_items,
      deleted_array: deletedItems,
      replacement_for_invoice_id: savedOriginalInvoiceId,
      // ✅ For F6: send null/0 for coupon
      // ✅ For F5: send actual coupon values
      coupon_id: isF6Flow ? null : couponId,
      coupon_amount: isF6Flow ? 0 : Number(coupon),
      coupon_business_type: finalBusinessType,
      // ✅ Yearly coupon specific fields
      yearly_coupon_id: isF6Flow ? null : yearlyCouponId,
      yearly_coupon_code: isF6Flow ? null : (isYearlyCoupon ? yearlyCouponCode : null),
      // // ✅ Referral coupon fields
      referral_coupon_id: isF6Flow ? null : referralCouponId,
      referral_coupon_code: isF6Flow ? null : referralCouponCode,

      discount_total: discount_total,
      // coupon_business_type: finalBusinessType,
    };

    console.log("Invoice Payload (DEBUG):", {
      isF6Flow,
      isYearlyCoupon,
      hasValidCoupon,
      hasValidReferralCoupon,
      total,
      coupon_id: payload.coupon_id,
      coupon_amount: payload.coupon_amount,
      yearly_coupon_id: payload.yearly_coupon_id,
      yearly_coupon_code: payload.yearly_coupon_code,
      // couponBusinessType: payload.invoice.coupon_business_type,
      savedCouponApplied,
      customerYearlyCouponStatus
    });

    if (savedInvoiceItems.length > 0 && savedCustomerId) {
      if (isInvoiceEditMode || type == 'edit') {
        let p = payload;
        p.invoice.id = searchParams.get("id");
        editInvoice.mutate(p);
      } else {
        setInvoiceTotal(payload.invoice.total);

        console.log('Final Payload for API:', payload);

        submitInvoice.mutate(payload);
      }
    } else {
      showErrorToast({ title: "Error", message: "Select customer / Please add invoice items." });
    }
  };

  // Fetching & Setting the data
  const invoiceId = searchParams.get("id");
  const isEditMode = window.location.pathname.includes("/edit");

  // Fetch invoice details in parallel and populate immediately for fast UI response
  const invoiceDetail = useQuery(
    ["invoice-detail", invoiceId],
    () => invoice_api.get_invoice_by_id(invoiceId),
    {
      enabled: isEditMode && !!invoiceId && !isInitialPopulated,
      onSuccess: res => {
        const data = res.data.data;
        setCustomerId(data.user);
        setPackingCharge(data.packing_charge);
        setInvoicesId(data.invoice_id);
        
        let coupon = coupons.find(value => value.id === data.coupon);
        if (coupon) {
          setCouponApplied(coupon);
          setCouponCode(coupon);
        }

        // Build the initial invoiceItemsList directly from data.invoice_item!
        const initialItems = data.invoice_item.map(item => {
          let itemBatches = [];
          if (item.batch) {
            itemBatches = Array.isArray(item.batch) ? item.batch : [item.batch];
          }
          const mappedBatches = itemBatches.map(x => ({
            id: x.id,
            batch_code: x.batch_no || x.batch_code,
            expiry_date: x.exp_date || x.expiry_date,
            stock: x.stock,
            total_stock: x.stock,
            mrp: x.mrp,
            price: x.selling_price || x.price,
          }));

          const selectedBatchObj = itemBatches.find(b => b.batch_no === item.batch_no) || item.batch || {};
          const selectedBatch = {
            id: item.counter_stock_batch || selectedBatchObj.id || item.batch?.id,
            batch_code: item.batch_no,
            batch_no: item.batch_no,
            mrp: selectedBatchObj.mrp || item.rate,
            price: item.rate,
            expiry_date: selectedBatchObj.exp_date || item.batch?.exp_date,
            stock: item.counter_stock || selectedBatchObj.stock || 0,
            total_stock: item.counter_stock || selectedBatchObj.stock || 0,
          };

          return {
            id: item.id,
            product_id: item.product,
            product_code: item.product_code,
            code: item.product_code,
            product_name: item.title,
            label: item.title,
            tax: item.tax || 0,
            price: item.rate,
            mrp: selectedBatch.mrp || item.rate,
            units: item.units,
            selected_unit: item.units,
            total_avl_stock: mappedBatches.reduce((sum, b) => sum + (b.stock || 0), 0),
            batches: mappedBatches,
            batch_code: item.batch_no,
            selected_batch: selectedBatch,
            qty: item.qty,
            entered_qty: item.qty,
            total: Number(item.amount),
            basic_amount: Number(item.taxable),
            tax_total: Number(item.tax_amount),
            discount: Number(item.discount_amount),
            discountPercentage: Number(item.discount),
            deleted: false,
            box: 0,
            pieces: 0,
            free_samples: 0,
          };
        });

        // Add products and batches of the invoice items to state
        setProductsList(prev => {
          const newItems = initialItems.map(item => ({
            code: item.product_code,
            product_code: item.product_code,
            product_name: item.product_name,
            tax: item.tax,
            price: item.price,
            mrp: item.mrp,
            units: item.units,
            batches: item.batches,
            total_avl_stock: item.total_avl_stock,
          }));
          const existingCodes = new Set(newItems.map(item => item.code));
          return [...newItems, ...prev.filter(item => !existingCodes.has(item.code))];
        });

        setBatches(prev => {
          const newBatches = initialItems.map(item => ({
            product_code: item.product_code,
            batches: item.batches,
          }));
          const existingCodes = new Set(newBatches.map(b => b.product_code));
          return [...newBatches, ...prev.filter(b => !existingCodes.has(b.product_code))];
        });

        setInvoiceItemsList(initialItems);
        setIsInitialPopulated(true);
        setIsEditing(true);
        setIsEditInvoiceMode(true);
        setTimeout(updateTotal, 100);
      }
    }
  );

  // Fetching & Setting the data
  const invoice_items = useQuery(["invoice-items-list", debouncedSearchValue], () => invoice_api.get_items(debouncedSearchValue, 1, 100), {
    onSuccess: async data => {
      // console.log("API Response ->", data.data); 
      const modifiedData = data.data.map(e => {
        const stock_filled_batch = e.counter_batch.filter(e => e.stock > 0);
        // console.log('000',e)
        const allBatches = e.counter_batch;
        return {
          counter_stock_id: e.id,
          product_code: e.product,
          code: e.product_code,
          product_name: e.title,
          tax: e.tax || 0,
          price: e.selling_price,
          mrp: e.mrp,
          units: e.units,
          total_avl_stock: allBatches?.reduce((sum, product) => sum + (product.stock || 0), 0),
          has_pending_merge: e.has_pending_merge,
          batches: allBatches.map(x => {
            return {
              id: x.id,
              batch_code: x.batch_no,
              expiry_date: x.exp_date,
              stock: x.stock,
              total_stock: x.stock,
              code: e.product_code,
              mrp: x.mrp,
              price: x.selling_price,
              hold_stock: x.hold_stock,
            };
          }),
        };
      });

      console.log("Modified Data:", modifiedData);

      // ✅ F5 FLOW / NEW INVOICE STOCK ADJUSTMENT:
      // Subtract quantities currently in invoiceItemsList from fetched stock to prevent resets during search
      if (!window.location.pathname.includes("/edit")) {
        // Track quantities in current invoiceItemsList (active, not deleted)
        const invoiceQuantitiesByProductAndBatch = {};
        invoiceItemsList.forEach(item => {
          if (!item.deleted) {
            const productCode = item.product_code;
            if (!invoiceQuantitiesByProductAndBatch[productCode]) {
              invoiceQuantitiesByProductAndBatch[productCode] = {};
            }
            invoiceQuantitiesByProductAndBatch[productCode][item.batch_code] =
              (invoiceQuantitiesByProductAndBatch[productCode][item.batch_code] || 0) + (parseFloat(item.qty) || 0);
          }
        });

        modifiedData.forEach(prod => {
          const usedBatches = invoiceQuantitiesByProductAndBatch[prod.product_code] || {};
          prod.batches = prod.batches.map(batch => {
            const qtyUsed = usedBatches[batch.batch_code] || 0;
            // Subtract the quantity already in the invoice from available stock
            const newStock = Math.max(0, Number(batch.stock) - qtyUsed);
            return {
              ...batch,
              stock: newStock,
              // total_stock remains the absolute total stock
            };
          });
        });
      }

      if (window.location.pathname.includes("/edit")) {
        // Track used batches for each product
        const usedBatchesByProduct = {};
        invoiceItemsList.forEach(item => {
          if (!item.deleted) {
            const productCode = item.product_id || item.product_code;
            if (!usedBatchesByProduct[productCode]) {
              usedBatchesByProduct[productCode] = {};
            }
            usedBatchesByProduct[productCode][item.batch_code] =
              (usedBatchesByProduct[productCode][item.batch_code] || 0) + Number(item.qty);
          }
        });

        modifiedData.forEach(prod => {
          const usedBatches = usedBatchesByProduct[prod.product_code] || {};

          prod.batches = prod.batches.map(batch => {
            const qtyUsed = usedBatches[batch.batch_code] || 0;

            if (qtyUsed > 0) {
              console.log(`Restoring ${qtyUsed} units to batch ${batch.batch_code} for product ${prod.product_code}`);
            }

            return {
              ...batch,
              stock: Number(batch.stock) + qtyUsed,
              total_stock: Number(batch.total_stock) + qtyUsed,
            };
          });
        });
      }

      setProductsList(prev => {
        const newItems = getModifiedList(modifiedData);
        const existingCodes = new Set(newItems.map(item => item.code));
        return [...newItems, ...prev.filter(item => !existingCodes.has(item.code))];
      });
      setProductsSearchList(getModifiedList(modifiedData));
      setBatches(prev => {
        const newBatches = modifiedData.map(e => ({
          product_code: e.product_code,
          batches: e.batches,
        }));
        const existingCodes = new Set(newBatches.map(b => b.product_code));
        return [...newBatches, ...prev.filter(b => !existingCodes.has(b.product_code))];
      });
    },
  });

  const SelectItem = forwardRef(({ image, label, description, ...others }, ref) => (
    <div {...others}>
      <Group noWrap>
        <Avatar src={image} />
        <div>
          <Text size="sm">{label}</Text>
          <Text size="xs" opacity={0.65}>
            {description}
          </Text>
        </div>
      </Group>
    </div>
  ));

  // Customer selection component validation
  const customer_ref = useRef(null);
  const handleCustomerSelection = async (value) => {
    setCustomerId(value);
    // Reset yearly coupon status
    setCustomerYearlyCouponStatus(null);
    setCustomerQualifiesForYearlyCoupon(false);
    setYearlyCouponCode(null);

    // Reset referral coupon
    setReferralCouponCode("");
    setSelectedReferralCoupon(null);
    setReferralCouponApplied(false);
    setReferralCouponError("");

    // Fetch customer yearly coupon status
    if (value) {
      fetchCustomerReferralCoupons(value);
      // Trigger refetch of yearly coupons to check for this customer
      yearlyCouponsQuery.refetch();
    }

    // Filter available coupons
    filterAvailableCoupons();
    // ⏭ Move cursor to Product Select
    setTimeout(() => {
      qty_ref.current?.focus();
    }, 0);
  };

  // Printing
  const navigateToPrint = () => {
    const invoice_items = invoiceItemsList.map(e => {
      return {
        id: e.id,
        counter_stock_id: e.selected_batch.id,
        counter_stock_batch_id: e.selected_batch.id,
        qty: e.qty,
        rate: e.price,
        amount: e.total,
        discount_amount: e.discount,
        tax: e.tax,
        tax_amount: e.tax_total,
      };
    });

    const payload = {
      invoice: {
        sub_total: +getTotal("subtotal"),
        tax_total: +getTotal("tax").toFixed(2),
        discount_total: +getTotal("discount"),
        total: +getTotal("amount"),
        // coupon_business_type: couponApplied?.business_type || null,
      },
      customer_id: customerId,
      invoice_item: invoice_items,
      deleted_array: deletedItems,
      coupon_id: couponApplied?.id || null,
    };
    navigate("/invoices/print", {
      state: payload,
    });
  };

  const qty_ref = useRef(null);
  const handleQtyOnFocus = () => {
    qty_ref.current?.focus();
  };

  const handleSubmit = (type) => {
    console.log("F5 pressed");
    // For F5, we don't pass isF6Flow parameter (defaults to false)
    saveInvoice(type, false);
  };

  const lastRef = useRef(null);

  useEffect(() => {
    if (lastRef.current) lastRef.current.focus();
  }, [invoiceItemsList.length]);

  const getExpiryDayLeft = expiry_date => {
    const expirationDate = new Date(expiry_date);
    const currentDate = new Date();
    const timeDifference = expirationDate.getTime() - currentDate.getTime();
    return Math.ceil(timeDifference / (1000 * 3600 * 24));
  };

  const optionsFilter = (value, item) => {
    if (!value) return true;
    const searchValue = value.toLowerCase().trim();
    // Split by dash to separate product code and batch code
    const parts = searchValue.split('-');
    const productCodeToSearch = parts[0];
    const batchCodeToSearch = parts[1];

    // First, filter by product code
    const productMatches = item.code?.toLowerCase().includes(productCodeToSearch) ||
      item.label?.toLowerCase().includes(productCodeToSearch);

    // If no batch code specified, return product matches
    if (!batchCodeToSearch) return productMatches;

    // If batch code is specified, also check if product has that batch
    if (item.batches) {
      const hasBatch = item.batches.some(batch =>
        batch.batch_code.toLowerCase().includes(batchCodeToSearch)
      );
      return productMatches && hasBatch;
    }

    return productMatches;
  };
  const applyHighlight = (el) => {
    if (!el) return;
    el.style.backgroundColor = '#e7f5ff';
    el.style.borderColor = '#22c55e';
    el.style.boxShadow = '0 0 0 4px rgba(34,197,94,0.25)';
  };

  const removeHighlight = (el) => {
    if (!el) return;
    el.style.backgroundColor = '';
    el.style.borderColor = '';
    el.style.boxShadow = '';
  };

  // Helper function to calculate available stock for a batch
  const getAvailableStockForBatch = (productCode, batchCode) => {
    // Find the batch
    const productBatch = batches.find(p => p.product_code === productCode);
    if (!productBatch) return 0;

    const batch = productBatch.batches.find(b => b.batch_code === batchCode);
    if (!batch) return 0;

    // Calculate what's already used in invoice
    const usedInInvoice = invoiceItemsList
      .filter(item =>
        item.product_code === productCode &&
        item.batch_code === batchCode &&
        !item.deleted
      )
      .reduce((sum, item) => sum + (parseFloat(item.qty) || 0), 0);

    // Available stock = total_stock - used_in_invoice
    const availableStock = Math.max(0, (batch.total_stock || 0) - usedInInvoice);

    return availableStock;
  };
  const handleSearchWithBatch = (productCode, batchCode) => {
    // Find the product
    const productToAdd = productsList.find(p => p.code === productCode);
    if (!productToAdd) {
      showErrorToast({ title: "Error", message: "Product not found." });
      return;
    }

    if (productToAdd?.has_pending_merge) {
      showErrorToast({
        title: "Merge Approval Required",
        message: "This product has a pending batch merge. Please complete the approval process before billing."
      });
      return;
    }

    // Find the specific batch
    const targetBatch = productToAdd.batches.find(b =>
      b.batch_code.toLowerCase() === batchCode.toLowerCase()
    );

    if (!targetBatch) {
      showErrorToast({
        title: "Error",
        message: `Batch '${batchCode}' not found for this product.`
      });
      return;
    }

    // Check if this exact batch already exists in invoice
    const existingExactBatch = invoiceItemsList.find(
      item => item.product_code === productToAdd.product_code &&
        item.batch_code === targetBatch.batch_code
    );

    if (existingExactBatch) {
      // ✅ If exact batch exists, add 1 to its quantity
      const newQty = (parseFloat(existingExactBatch.qty) || 0) + 1;

      // Check if there's enough stock
      if (newQty > existingExactBatch.selected_batch.total_stock) {
        showErrorToast({
          title: "Insufficient Stock",
          message: `Only ${existingExactBatch.selected_batch.total_stock} units available`
        });
        return;
      }

      // Update the existing item
      setInvoiceItemsList(
        produce(draft => {
          const item = draft.find(
            i => i.product_code === productToAdd.product_code &&
              i.batch_code === targetBatch.batch_code
          );
          if (item) {
            item.qty = newQty;
            item.entered_qty = newQty;
            item.basic_amount = item.selected_batch.price * newQty;

            // Recalculate discount and total
            const discountAmount = (item.basic_amount * item.discountPercentage) / 100;
            item.discount = discountAmount;
            const amountAfterDiscount = item.basic_amount - discountAmount;

            const taxPercentage = item.tax || 0;
            const denominator = 100 + taxPercentage;
            const tax = (amountAfterDiscount - (amountAfterDiscount / denominator) * 100).toFixed(2);

            item.tax_total = Number(tax);
            item.total = amountAfterDiscount;
          }
        })
      );

      showSuccessToast({
        title: "Quantity Updated",
        message: `Added 1 to ${productToAdd.label} (${targetBatch.batch_code})`
      });

      updateTotal();
      return;
    }

    // If target batch has zero stock, look for alternative batches
    if (targetBatch.stock <= 0) {
      // Find other batches for this product that ARE in the invoice
      const existingBatchesInInvoice = invoiceItemsList.filter(
        item => item.product_code === productToAdd.product_code
      );

      if (existingBatchesInInvoice.length > 0) {
        // Try to add to the first existing batch
        const batchToUse = existingBatchesInInvoice[0];
        const newQty = (parseFloat(batchToUse.qty) || 0) + 1;

        // Check stock availability
        if (newQty > batchToUse.selected_batch.total_stock) {
          showErrorToast({
            title: "Insufficient Stock",
            message: `Cannot add more to ${batchToUse.batch_code}`
          });
          return;
        }

        // Update the existing batch
        setInvoiceItemsList(
          produce(draft => {
            const item = draft.find(
              i => i.product_code === batchToUse.product_code &&
                i.batch_code === batchToUse.batch_code
            );
            if (item) {
              item.qty = newQty;
              item.entered_qty = newQty;
              item.basic_amount = item.selected_batch.price * newQty;

              // Recalculate discount and total
              const discountAmount = (item.basic_amount * item.discountPercentage) / 100;
              item.discount = discountAmount;
              const amountAfterDiscount = item.basic_amount - discountAmount;

              const taxPercentage = item.tax || 0;
              const denominator = 100 + taxPercentage;
              const tax = (amountAfterDiscount - (amountAfterDiscount / denominator) * 100).toFixed(2);

              item.tax_total = Number(tax);
              item.total = amountAfterDiscount;
            }
          })
        );

        showSuccessToast({
          title: "Added to Existing Batch",
          message: `Added to ${batchToUse.product_name} (${batchToUse.batch_code}) instead`
        });

        updateTotal();
        return;
      }
    }

    // If no existing batch found and target batch has stock, create new item
    if (targetBatch.stock > 0) {
      // Create new invoice item
      const newItem = createInvoiceItem(
        productToAdd,
        targetBatch,
        1, // Default quantity
        0  // Default discount
      );

      addInvoiceItem(newItem);

      // Update batch stock
      setBatches(
        produce(draft => {
          const productBatch = draft.find(p => p.product_code === productToAdd.product_code);
          if (productBatch) {
            const batchIndex = productBatch.batches.findIndex(b => b.batch_code === targetBatch.batch_code);
            if (batchIndex !== -1) {
              productBatch.batches[batchIndex].stock = Math.max(0, targetBatch.stock - 1);
            }
          }
        })
      );

      showSuccessToast({
        title: "Product Added",
        message: `${productToAdd.label} (${targetBatch.batch_code}) added to invoice`
      });

      updateTotal();
    } else {
      showErrorToast({
        title: "No Stock Available",
        message: "No stock available for this product in any batch"
      });
    }
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "F1") {
        event.preventDefault();

        console.log("F1 pressed - Focusing customer input");

        // Show toast notification
        showSuccessToast({
          title: "Customer Search",
          message: "Focusing customer search input..."
        });

        setTimeout(() => {
          const customerInputs = document.querySelectorAll('input');
          let customerInput = null;

          // Look for customer input by common attributes
          customerInputs.forEach(input => {
            const placeholder = input.placeholder?.toLowerCase() || '';
            const id = input.id?.toLowerCase() || '';
            const className = input.className?.toLowerCase() || '';

            if (placeholder.includes('customer') ||
              placeholder.includes('search') ||
              id.includes('customer') ||
              className.includes('customer')) {
              customerInput = input;
            }
          });

          if (customerInput) {
            console.log("Found customer input by search:", customerInput);

            // focus + select (existing)
            customerInput.focus();
            customerInput.select();

            // 🔹 focus highlight
            applyHighlight(customerInput);

            // 🔹 auto remove focus highlight
            setTimeout(() => {
              removeHighlight(customerInput);
            }, 2000);

            // 🔹 ADD hover effect (ONLY ONCE)
            if (!customerInput.dataset.hoverBound) {
              customerInput.dataset.hoverBound = "true";

              customerInput.addEventListener("mouseenter", () => {
                applyHighlight(customerInput);
              });

              customerInput.addEventListener("mouseleave", () => {
                removeHighlight(customerInput);
              });
            }
          }
          else {
            console.log("Could not find customer input, trying alternative...");
          }
        }, 100);
      }
      if (event.key === "F2") {
        event.preventDefault();

        // Run your existing focus helper
        setTimeout(() => {
          handleQtyOnFocus();


          const wrapper = qty_ref.current;
          if (wrapper) {
            const controlEl = wrapper.querySelector("[data-mantine-select-target]");
            if (controlEl) {
              controlEl.click(); // open dropdown
            }
          }
        }, 30);
      }

      if (event.key === "F3") {
        event.preventDefault();
        setTimeout(() => {
          const couponInput = document.querySelector(
            'input[placeholder*="Enter Coupon Code"]'
          );
          if (couponInput) {
            couponInput.focus();
            couponInput.select();
            setActiveShortcut("coupon");

            setTimeout(() => setActiveShortcut(null), 2000);
          }
        }, 30);
      }


      if (event.key === "F4") {
        event.preventDefault();
        setTimeout(() => {
          const discountInput = document.querySelector(
            'input[placeholder*="Enter net discount"]'
          );
          if (discountInput) {
            discountInput.focus();
            discountInput.select();
            setActiveShortcut("discount");

            setTimeout(() => setActiveShortcut(null), 2000);
          }
        }, 30);
      }


      // Tab navigation - when tab reaches list
      if (event.key === 'Tab' && isListFocused && !selectedRow && invoiceItemsList.length > 0) {
        // Auto-select first row when tab enters the list
        const firstItem = invoiceItemsList[0];
        const firstUniqueId = `${firstItem.product_code}_${firstItem.batch_code}`;
        setSelectedRow(firstUniqueId);
        event.preventDefault(); // Keep focus in the list
      }

      // Arrow key navigation for rows (only when list is focused)
      if ((event.key === 'ArrowDown' || event.key === 'ArrowUp') && isListFocused) {
        event.preventDefault();
        handleArrowKeyNavigation(event.key);
      }
      // Enter key for selected row editing
      if (event.key === 'Enter' && selectedRow && isListFocused && !isEditingMode) {
        event.preventDefault();
        const selectedItem = invoiceItemsList.find(item =>
          `${item.product_code}_${item.batch_code}` === selectedRow
        );
        if (selectedItem) {
          handleEditItem(selectedItem);
        }
      }
      // Tab to exit list
      if (event.key === 'Tab' && isListFocused && selectedRow && event.shiftKey === false) {
        // Allow normal tab behavior to move to next element
        setIsListFocused(false);
        setSelectedRow(null);
      }

      // ============================
      // Print & Save → Alt + F5
      // ============================
      if (event.key === "F5" && event.altKey) {
        event.preventDefault();

        // ✅ Validation: Block if total is 0 or negative
        const currentTotalAmount = parseFloat(getTotal("amount")) || 0;

        if (currentTotalAmount <= 0) {
          showErrorToast({
            title: "Invalid Total",
            message: "Invoice total must be greater than 0 to proceed with Print & Save."
          });
          return;
        }

        window.runStockRef = false;   // IMPORTANT: stock reference should NOT run

        const isEditPage = window.location.pathname.includes("/edit");
        setIsInvoiceEditMode(isEditPage);

        setPayAndPrintBill(true);
        setIsF6Mode(false); // Not F6 mode

        setTimeout(() => {
          if (isEditPage) {
            handleSubmit("edit");
          } else {
            handleSubmit();
          }
        }, 100);

        return;
      }

      // ============================
      // Save Invoice → F6
      // ============================
      if (event.key === "F6") {
        event.preventDefault();

        // ✅ Validation: Block if total is 0 or negative
        const currentTotalAmount = parseFloat(getTotal("amount")) || 0;

        if (currentTotalAmount <= 0) {
          showErrorToast({
            title: "Invalid Total",
            message: "Invoice total must be greater than 0 to proceed."
          });
          return;
        }

        window.runStockRef = true;    // IMPORTANT: stock reference SHOULD run

        setPayAndPrintBill(false);
        setIsF6Mode(true); // Set F6 mode

        setTimeout(() => {
          saveInvoice(null, true);
          // Reset after a delay
          setTimeout(() => setIsF6Mode(false), 1000);
        }, 100);

        return;
      }


    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [selectedRow, isEditingMode, invoiceItemsList, isListFocused, customerId, customers, isCustomerHighlighted, couponApplied, packingCharge, selectedReferralCoupon, yearlyCouponCode]);

  useEffect(() => {
    if (customerId && customers.length > 0) {
      const selected = customers.find(c => c.id === customerId);
      if (selected) {
        setCustomerSearch(
          selected.name || selected.mobile || ""
        );
      }
    }
  }, [customerId, customers]);

  // Add this function to recalculate when coupon changes
  const recalculateWithCoupon = () => {
    if (couponApplied && couponApplied.id) {
      updateTotal();
    }
  };

  // Call this when coupon is applied/removed
  useEffect(() => {
    recalculateWithCoupon();
  }, [couponApplied]);

  // Update batch button stock display when invoice items change
  useEffect(() => {
    // This will force a re-render of the batch button
    // The available stock calculation happens in the render function above
  }, [invoiceItemsList, batches, selectedBatchCode, isEditingMode, editingItem]);

  useEffect(() => {
    sessionStorage.setItem("invoiceItems", JSON.stringify(invoiceItemsList || []));

    sessionStorage.setItem("customerId", customerId || '');

    sessionStorage.setItem("couponApplied", JSON.stringify(couponApplied || {}))

    sessionStorage.setItem("packingCharge", packingCharge || 0)
  }, [invoiceItemsList, customerId, couponApplied, packingCharge]);



  console.log("Invoice Items List Before Deletion:", invoiceItemsList);

  const isProductSelected = isEditingMode || !!selectedBatchCode;
  const isProductSearchActive = Boolean(searchValue.trim());
  const productDropdownData = React.useMemo(() => {
    const source = isProductSearchActive ? productsSearchList : productsList;
    return [...(source || [])].sort((a, b) => (a.label || "").localeCompare(b.label || ""));
  }, [isProductSearchActive, productsList, productsSearchList]);
  const resolveProductFromList = productIdentifier =>
    productsList.find(
      product => product.code === productIdentifier || product.product_code === productIdentifier
    );
  const modalProductLabel =
    selectedProductName ||
    editProductName ||
    resolveProductFromList(selectedProductCode)?.label ||
    resolveProductFromList(editingItem?.code)?.label ||
    resolveProductFromList(editingItem?.product_code)?.label ||
    editingItem?.product_name ||
    "";



  return (

    <>
      {!isMobileScreen && (
        <Box
          style={{
            height: "100vh", // full height
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            position: "relative"
          }}>
          {/* ✅ STICKY HEADER */}
          <Box
            shadow="sm" radius="md" p="xs" withBorder
            style={{
              position: "fixed",
              flex: "0 0 auto",
              top: "145px",
              left: "1%",
              right: "400px",
              zIndex: 100,
              boxShadow: "0 -2px 8px rgba(0, 0, 0, 0.18)",
              alignItems: "center",
              padding: "6px 10px",
              background: "#fff",
              borderBottom: "1px solid #ddd",
              borderRadius: "8px",
              width: "calc(100% - 410px)",
              height: "185px", // Fixed height to force reduction
              minHeight: "185px", // Prevent growing
              maxHeight: "185px", // Prevent expanding
            }}
          >
            <Container fluid style={{ width: "100%", height: "100%" }}>
              {/* <Card shadow="sm" radius="md" p="sm" withBorder style={{ padding:"6px 10px",  marginBottom: 0  }} > */}
              <Flex justify={"space-between"} align="start" style={{ height: "100%" }}>
                <Card style={{ width: "auto", minWidth: "300px", height: "100%" }}>
                  <Group spacing="sm" align="center" mb={2}>
                    <Text size={"lg"} fw={600}>
                      {originalInvoiceNo ? `Replacement Invoice (For ${originalInvoiceNo})` : 'Create Invoice'}
                    </Text>
                    {exchangeRefundCredit > 0 && (
                      <Badge color="teal" variant="filled" size="xs">
                        Exchange Credit Active: -₹{exchangeRefundCredit.toFixed(2)}
                      </Badge>
                    )}
                  </Group>
                  <Breadcrumbs separator="/" sx={{ fontSize: 14 }}>
                    <Anchor href="/">Home</Anchor>
                    <Anchor href="/">Transactions</Anchor>
                    <Anchor>Invoice</Anchor>
                  </Breadcrumbs>

                  {/* Add Product Search Box */}
                  <Group mt={6} align="center">
                    {isEditingMode ? (
                      <Text
                        fw={600}
                        color="white"
                        bg="yellow"
                        px={10}
                        py={5}
                        style={{
                          borderRadius: '8px',
                          display: 'inline-block'
                        }}
                      >
                        Editing
                      </Text>
                    ) : (
                      <Text fw={600}>
                        Add Products
                      </Text>
                    )}

                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <Select
                        value={selectedProductName || ""}
                        searchValue={selectedProductName ? selectedProductName : searchValue}
                        onSearchChange={(val) => {
                          if (!lockFocus) {
                            setProductsSearchList([]);
                            setSearchValue(val);
                            // Clear selected product when user starts typing
                            if (val && selectedProductCode) {
                              setSelectedProductCode(null);
                              setSelectedProductName("");
                            }
                          }
                        }}
                        disabled={false}
                        icon={<IconSearch style={{ left: 10, width: 18 }} />}
                        placeholder={selectedProductName ? selectedProductName : "Click here to add Invoice Item (F2)"}
                        data={productDropdownData}
                        ref={qty_ref}
                        searchable
                        withinPortal
                        zIndex={100}
                        dropdownPosition="bottom"
                        rightSection={invoice_items.isFetching ? <Loader size="xs" /> : null}
                        styles={{
                          dropdown: {
                            zIndex: 100,
                          },
                          input: {
                            border: "1px solid #d8dce0ff",
                            borderRadius: "6px",
                            backgroundColor: isEditingMode ? "#fcf2daf7" : "white",
                          },
                        }}
                        maxDropdownHeight={120}
                        sx={{ flex: 1, fontSize: "14px", minWidth: "350px" }}
                        nothingFound="No products found"
                        filter={() => true}
                        onChange={(productCode) => {
                          if (!productCode) return;

                          // const selectedProduct = productsList.find(p => p.code === productCode);
                          // setSelectedProductCode(productCode);
                          // setSelectedProductName(selectedProduct?.label || ""); // Store product name
                          // console.log("Total products list",productsList)
                          let batchCode = null;
                          let selectedProduct = productsList.find(p => p.code === productCode);
                          if (!selectedProduct) return;

                          if (selectedProduct?.has_pending_merge) {
                            showErrorToast({
                              title: "Merge Approval Required",
                              message: "This product has a pending batch merge. Please complete the approval process before billing."
                            });
                            navigate("/batch-merge-approvals");
                            return;
                          }

                          const productUnit = selectedProduct.units;
                          setLastSelectedProductUnit(productUnit);

                          if (searchValue.includes("-")) {
                            const parts = searchValue.split("-");
                            if (parts[0] === productCode) {
                              batchCode = parts[1]?.trim();
                            }
                          }
                          let selectedBatch = null;

                          if (batchCode) {
                            // Find the specific batch
                            selectedBatch = selectedProduct.batches.find(b =>
                              b.batch_code.toLowerCase() === batchCode.toLowerCase()
                            );

                            if (!selectedBatch) {
                              showErrorToast({
                                title: "Batch Not Found",
                                message: `Batch "${batchCode}" not found`
                              });
                              return;
                            }
                          } else {
                            // Use first available batch
                            selectedBatch = selectedProduct.batches.find(batch => batch.stock > 0) || selectedProduct.batches[0];
                          }

                          if (!selectedBatch) {
                            showErrorToast({
                              title: "No Batch Available",
                              message: "No batches available for this product"
                            });
                            return;
                          }
                          // ✅ NEW: Auto-fill quantity for NOS/PCS units
                          const isNosUnit = !isDecimalUnit(productUnit); // NOS, PCS, etc.

                          if (isNosUnit) {
                            // Auto-fill with 1 for NOS/PCS units
                            setTempQty(1);

                          } else {
                            // Leave empty for KG units
                            setTempQty("");
                          }
                          // Check if exists in invoice (exact match batch first, fallback to any batch)
                          let existingItem = invoiceItemsList.find(
                            item => item.product_code === selectedProduct.product_code &&
                              item.batch_code === selectedBatch.batch_code &&
                              item.deleted === false
                          );

                          if (!existingItem) {
                            existingItem = invoiceItemsList.find(
                              item => item.product_code === selectedProduct.product_code &&
                                item.deleted === false
                            );
                          }

                          if (existingItem) {
                            // 🟢 ENTER EDIT MODE WITH AUTO-INCREASE QTY BY 1 (IF STOCK AVAILABLE)
                            const currentQty = parseFloat(existingItem.qty) || 0;
                            const targetQty = currentQty + 1;

                            // Calculate total available stock for this item
                            let totalAvailableStock = 0;
                            const productBatch = batches.find(p => p.product_code === existingItem.product_code);
                            if (productBatch?.batches) {
                              const targetBatchCode = existingItem.batch_code;
                              const selectedBatch = productBatch.batches.find(b => b.batch_code === targetBatchCode);
                              if (selectedBatch) {
                                totalAvailableStock += selectedBatch.total_stock || 0;
                              }
                              productBatch.batches.forEach(batch => {
                                if (batch.batch_code !== targetBatchCode) {
                                  totalAvailableStock += batch.stock || 0;
                                }
                              });
                            }
                            totalAvailableStock = parseFloat(totalAvailableStock.toFixed(2));

                            let qtyToSet = currentQty;
                            if (targetQty <= totalAvailableStock) {
                              qtyToSet = targetQty;
                              showSuccessToast({
                                title: "Editing Mode",
                                message: `Quantity increased to ${qtyToSet}. Press Enter to confirm or Esc to cancel.`
                              });
                            } else {
                              showErrorToast({
                                title: "Insufficient Stock",
                                message: `Only ${totalAvailableStock} units available. Loading existing quantity.`
                              });
                            }

                            const uniqueId = `${existingItem.product_code}_${existingItem.batch_code}`;
                            setSelectedRow(uniqueId);
                            setEditingItem({
                              ...existingItem,
                              uniqueId: uniqueId,
                              qty: qtyToSet
                            });
                            setIsEditingMode(true);
                            setSelectedProductCode(existingItem.code || existingItem.product_code);
                            setSelectedProductName(existingItem.product_name || existingItem.label || "");
                            setEditProductName(existingItem.product_name || existingItem.label || "");
                            setEditBatchCode(existingItem.batch_code || "");
                            setEditQty(qtyToSet);
                            setEditDiscount(existingItem.discountPercentage || 0);
                            setSelectedBatchCode(existingItem.batch_code);
                            setTempQty(qtyToSet);
                            setTempDiscount(existingItem.discountPercentage || 0);

                            updateModalBatches(existingItem.product_code);

                            setTimeout(() => {
                              const qtyInput = document.getElementById("temp_qty_input");
                              if (qtyInput) {
                                qtyInput.focus();
                                qtyInput.select();
                              }
                            }, 100);

                            setSearchValue("");
                            return; // Stop further execution
                          }

                          // If not a duplicate, proceed with normal selection
                          setSelectedProductCode(productCode);
                          setSelectedProductName(selectedProduct?.label || "");
                          setSelectedBatchCode(selectedBatch.batch_code);
                          setSelectedBatchName(selectedBatch.batch_code);

                          // Auto-focus to quantity input
                          setTimeout(() => {
                            document.getElementById("temp_qty_input")?.focus();
                            document.getElementById("temp_qty_input")?.select();
                          }, 100);


                          setSearchValue("");
                        }}
                        onKeyDown={(event) => {
                          if (event.key === "Enter" && searchValue) {
                            event.preventDefault();
                            // Check if input is in "productCode-batchCode" format
                            // if (searchValue.includes("-")) {
                            //   const parts = searchValue.split("-");
                            //   const productCode = parts[0].trim();
                            //   const batchCode = parts[1]?.trim();

                            //   if (productCode && batchCode) {
                            //     // Use the new search with batch logic
                            //     handleSearchWithBatch(productCode, batchCode);
                            //     setSearchValue("");
                            //     return;
                            //   }
                            // }
                            let productCode = searchValue;
                            let batchCode = null;
                            let selectedBatch = null;
                            // Check if input is in "productCode-batchCode" format
                            if (searchValue.includes("-")) {
                              const parts = searchValue.split("-");
                              productCode = parts[0].trim();
                              batchCode = parts[1]?.trim(); // Get batch code if exists
                            }
                            const selectedProduct = productsList.find(p => p.code === productCode) ||
                              productsList.find(p => p.code.toLowerCase() === searchValue.toLowerCase());
                            if (!selectedProduct) {
                              return;
                            }

                            if (selectedProduct?.has_pending_merge) {
                              showErrorToast({
                                title: "Merge Approval Required",
                                message: "This product has a pending batch merge. Please complete the approval process before billing."
                              });
                              navigate("/batch-merge-approvals");
                              return;
                            }
                            // Store the unit type
                            const productUnit = selectedProduct.units;
                            setLastSelectedProductUnit(productUnit);
                            if (batchCode) {
                              // User provided specific batch code
                              selectedBatch = selectedProduct.batches.find(b =>
                                b.batch_code.toLowerCase() === batchCode.toLowerCase()
                              );

                              if (!selectedBatch) {
                                showErrorToast({
                                  title: "Batch Not Found",
                                  message: `Batch "${batchCode}" not found for product "${selectedProduct.label}"`
                                });
                                return;
                              }
                            } else {
                              // No batch specified, use first available
                              selectedBatch = selectedProduct.batches.find(batch => batch.stock > 0) || selectedProduct.batches[0];
                            }

                            if (!selectedBatch) {
                              showErrorToast({
                                title: "No Batch Available",
                                message: "No batches available for this product"
                              });
                              return;
                            }
                            // ✅ NEW: Auto-fill quantity for NOS/PCS units
                            const isNosUnit = !isDecimalUnit(productUnit);

                            setTempQty(isNosUnit ? 1 : "");
                            // ✅ CHECK IF PRODUCT+BATCH ALREADY EXISTS IN INVOICE (exact match first, fallback to any batch)
                            let existingItem = invoiceItemsList.find(
                              item => item.product_code === selectedProduct.product_code &&
                                item.batch_code === selectedBatch.batch_code &&
                                item.deleted === false
                            );

                            if (!existingItem) {
                              existingItem = invoiceItemsList.find(
                                item => item.product_code === selectedProduct.product_code &&
                                  item.deleted === false
                              );
                            }

                            if (existingItem) {
                              // 🟢 ENTER EDIT MODE WITH AUTO-INCREASE QTY BY 1 (IF STOCK AVAILABLE)
                              const currentQty = parseFloat(existingItem.qty) || 0;
                              const targetQty = currentQty + 1;

                              // Calculate total available stock for this item
                              let totalAvailableStock = 0;
                              const productBatch = batches.find(p => p.product_code === existingItem.product_code);
                              if (productBatch?.batches) {
                                const targetBatchCode = existingItem.batch_code;
                                const selectedBatch = productBatch.batches.find(b => b.batch_code === targetBatchCode);
                                if (selectedBatch) {
                                  totalAvailableStock += selectedBatch.total_stock || 0;
                                }
                                productBatch.batches.forEach(batch => {
                                  if (batch.batch_code !== targetBatchCode) {
                                    totalAvailableStock += batch.stock || 0;
                                  }
                                });
                              }
                              totalAvailableStock = parseFloat(totalAvailableStock.toFixed(2));

                              let qtyToSet = currentQty;
                              if (targetQty <= totalAvailableStock) {
                                qtyToSet = targetQty;
                                showSuccessToast({
                                  title: "Editing Mode",
                                  message: `Quantity increased to ${qtyToSet}. Press Enter to confirm or Esc to cancel.`
                                });
                              } else {
                                showErrorToast({
                                  title: "Insufficient Stock",
                                  message: `Only ${totalAvailableStock} units available. Loading existing quantity.`
                                });
                              }

                              const uniqueId = `${existingItem.product_code}_${existingItem.batch_code}`;
                              setSelectedRow(uniqueId);
                              setEditingItem({
                                ...existingItem,
                                uniqueId: uniqueId,
                                qty: qtyToSet
                              });
                              setIsEditingMode(true);
                              setSelectedProductCode(existingItem.code || existingItem.product_code);
                              setSelectedProductName(existingItem.product_name || existingItem.label || "");
                              setEditProductName(existingItem.product_name || existingItem.label || "");
                              setEditBatchCode(existingItem.batch_code || "");
                              setEditQty(qtyToSet);
                              setEditDiscount(existingItem.discountPercentage || 0);
                              setSelectedBatchCode(existingItem.batch_code);
                              setTempQty(qtyToSet);
                              setTempDiscount(existingItem.discountPercentage || 0);

                              updateModalBatches(existingItem.product_code);

                              setTimeout(() => {
                                const qtyInput = document.getElementById("temp_qty_input");
                                if (qtyInput) {
                                  qtyInput.focus();
                                  qtyInput.select();
                                }
                              }, 100);

                              setSearchValue("");
                              return; // Stop further execution
                            }

                            // If not a duplicate, proceed with normal selection
                            setSelectedProductCode(productCode);
                            setSelectedProductName(selectedProduct?.label || "");
                            setSelectedBatchCode(selectedBatch.batch_code);
                            setSelectedBatchName(selectedBatch.batch_code);

                            // Auto-focus to quantity input
                            setTimeout(() => {
                              document.getElementById("temp_qty_input")?.focus();
                              document.getElementById("temp_qty_input")?.select();
                            }, 100);
                            setSearchValue("");
                          }
                        }}
                      />
                      <Badge
                        color="green"
                        variant="filled"
                        size="lg"
                        style={{
                          minWidth: 90,
                          textAlign: "center",
                          marginTop: "-2px"
                        }}
                      >
                        Qty: {totalBatchQty}
                      </Badge>
                    </div>

                    {/* Batch Selection Button */}
                    <div style={{ width: 192, flexShrink: 0 }}>
                      <Button
                        variant="subtle"
                        color="green"
                        size="xs"
                        px={4}
                        onClick={() => {
                          if (isEditingMode) {
                            updateModalBatches(editingItem.product_code);
                            setProductSelectionModal(true);
                          } else if (!selectedProductCode) {
                            showErrorToast({
                              title: "Error",
                              message: "Please select a product first!"
                            });
                            return;
                          } else {
                            updateModalBatches(selectedProductCode);
                            setProductSelectionModal(true);
                          }
                        }}>
                        <Badge
                          sx={{
                            width: "192px",              // ✅ fixed width
                            minWidth: "192px",
                            display: "flex",             // ✅ enable centering
                            justifyContent: "center",    // ✅ horizontal center
                            alignItems: "center",        // ✅ vertical center
                            whiteSpace: "nowrap",        // ✅ prevent wrapping
                            color: (selectedBatchCode || (isEditingMode && editBatchCode)) ? "white" : "gray",
                            borderColor: (selectedBatchCode || (isEditingMode && editBatchCode)) ? "orange" : "lightgray",
                            backgroundColor: (selectedBatchCode || (isEditingMode && editBatchCode)) ? "#FF922B" : "lightgray",
                            fontSize: '10px',
                            height: '29px',
                            lineHeight: '20px',
                            marginTop: "7px",
                            // marginLeft:"5px"
                          }}
                          variant={(selectedBatchCode || (isEditingMode && editBatchCode)) ? "filled" : "outline"}
                          mb={5}
                          disabled={!selectedProductCode && !isEditingMode}
                        >
                          {(() => {
                            // Get the current batch based on mode
                            let currentBatch = null;
                            let productCode = null;
                            let batchCode = null;

                            if (isEditingMode && editingItem) {
                              // Editing mode: calculate available stock for the batch
                              productCode = editingItem.product_code;
                              batchCode = selectedBatchCode || editingItem.batch_code;
                            } else if (selectedBatchCode && selectedProductCode) {
                              // Normal mode
                              const productToAdd = productsList.find(p => p.code === selectedProductCode);
                              if (productToAdd) {
                                productCode = productToAdd.product_code;
                                batchCode = selectedBatchCode;
                              }
                            }

                            // Get available stock using the helper function
                            let availableStock = 0;
                            if (productCode && batchCode) {
                              availableStock = getAvailableStockForBatch(productCode, batchCode);
                            }

                            // Format the display text
                            const batchDisplay = isEditingMode
                              ? (selectedBatchCode || editingItem?.batch_code || "Select Batch")
                              : (selectedBatchCode || "Select Batch");

                            // Add available stock count if we have a batch
                            if (productCode && batchCode && availableStock >= 0) {
                              // Show with appropriate decimal places based on unit
                              let displayAvailableStock = availableStock;

                              // Check if it's a decimal unit
                              let isDecimal = false;
                              if (isEditingMode && editingItem) {
                                const productUnit = productsList.find(p => p.product_code === editingItem?.product_code)?.units;
                                isDecimal = isDecimalUnit(productUnit);
                              } else if (selectedProductCode) {
                                const productUnit = productsList.find(p => p.code === selectedProductCode)?.units;
                                isDecimal = isDecimalUnit(productUnit);
                              }

                              if (isDecimal) {
                                displayAvailableStock = availableStock.toFixed(3);
                              } else {
                                displayAvailableStock = Math.floor(availableStock);
                              }

                              return `${batchDisplay} (${displayAvailableStock})`;
                            }

                            return batchDisplay;
                          })()}
                        </Badge>
                      </Button>
                    </div>

                    {/* Quantity Input */}
                    <Button
                      color={isProductSelected ? "orange" : "gray"}
                      variant={isProductSelected ? "filled" : "filled"}
                      size="xs"
                      px={3}
                      ml={8}>
                      <NumberInput
                        id="temp_qty_input"
                        decimalSeparator="."
                        type="number"
                        allowDecimal={isEditingMode ?
                          isDecimalUnit(productsList.find(p => p.product_code === editingItem?.product_code)?.units || "PCS") :
                          selectedProductCode ? isDecimalUnit(productsList.find(p => p.code === selectedProductCode)?.units || "PCS") : false
                        }
                        precision={isEditingMode ?
                          (isDecimalUnit(productsList.find(p => p.product_code === editingItem?.product_code)?.units || "PCS") ? 3 : 0) :
                          (selectedProductCode && isDecimalUnit(productsList.find(p => p.code === selectedProductCode)?.units || "PCS") ? 3 : 0)
                        }
                        step={isEditingMode ?
                          (isDecimalUnit(productsList.find(p => p.product_code === editingItem?.product_code)?.units || "PCS") ? 0.001 : 1) :
                          (selectedProductCode && isDecimalUnit(productsList.find(p => p.code === selectedProductCode)?.units || "PCS") ? 0.001 : 1)
                        }
                        value={isEditingMode ? editingItem?.qty || 0 : tempQty || ""}
                        onChange={(val) => {
                          if (isEditingMode) {
                            setEditingItem(prev => ({ ...prev, qty: val }));
                            // ✅ IMMEDIATE VALIDATION ONLY FOR EDITING MODE
                            if (val && val > 0) {
                              const quantity = parseFloat(val) || 0;
                              let totalAvailableStock = 0;

                              const productBatch = batches.find(p => p.product_code === editingItem.product_code);
                              if (productBatch?.batches) {
                                const targetBatchCode = selectedBatchCode || editingItem.batch_code;
                                const selectedBatch = productBatch.batches.find(b => b.batch_code === targetBatchCode);
                                if (selectedBatch) {
                                  totalAvailableStock += selectedBatch.total_stock || 0;
                                }
                                productBatch.batches.forEach(batch => {
                                  if (batch.batch_code !== targetBatchCode) {
                                    totalAvailableStock += batch.stock || 0;
                                  }
                                });
                              }
                              totalAvailableStock = parseFloat(totalAvailableStock.toFixed(2));

                              // ✅ IMMEDIATE ERROR ONLY FOR EDITING MODE
                              if (quantity > totalAvailableStock) {
                                showErrorToast({
                                  title: "Insufficient Stock",
                                  message: `Only ${totalAvailableStock} units available`
                                });

                                // ✅ KEEP FOCUS IN QTY INPUT FOR EDITING MODE
                                setTimeout(() => {
                                  const qtyInput = document.getElementById("temp_qty_input");
                                  if (qtyInput) {
                                    qtyInput.focus();
                                    qtyInput.select();
                                  }
                                }, 100);
                              }
                            }
                          } else {
                            setTempQty(val);
                          }
                        }}
                        size="xs"
                        w={80}
                        placeholder="Qty"
                        disabled={!selectedBatchCode && !isEditingMode}

                        // ✅ FIXED ONBLUR VALIDATION - Properly handle edit mode batch changes
                        onBlur={(event) => {
                          const enteredQty = parseFloat(event.target.value) || 0;

                          if (enteredQty > 0) {
                            let totalAvailableStock = 0;

                            if (isEditingMode && editingItem) {
                              // For editing mode - get TOTAL stock across all batches
                              const productBatch = batches.find(p => p.product_code === editingItem.product_code);
                              if (productBatch?.batches) {
                                const targetBatchCode = selectedBatchCode || editingItem.batch_code;

                                // Find the selected batch first
                                const selectedBatch = productBatch.batches.find(b => b.batch_code === targetBatchCode);
                                if (selectedBatch) {
                                  // Add selected batch's TOTAL stock
                                  totalAvailableStock += selectedBatch.total_stock || 0;
                                  console.log(`Selected batch ${targetBatchCode}: total_stock = ${selectedBatch.total_stock}`);
                                }

                                // Add other batches' CURRENT stock
                                productBatch.batches.forEach(batch => {
                                  if (batch.batch_code !== targetBatchCode) {
                                    totalAvailableStock += batch.stock || 0;
                                    console.log(`Other batch ${batch.batch_code}: stock = ${batch.stock}`);
                                  }
                                });

                                console.log(`Total available: ${totalAvailableStock} (Selected batch total + Other batches current)`);
                              }
                            } else if (selectedBatchCode) {
                              // For new product mode: Same logic
                              const productToAdd = productsList.find(p => p.code === selectedProductCode);
                              const productBatch = batches.find(p => p.product_code === productToAdd?.product_code);
                              if (productBatch?.batches) {
                                const selectedBatch = productBatch.batches.find(b => b.batch_code === selectedBatchCode);
                                if (selectedBatch) {
                                  totalAvailableStock += selectedBatch.total_stock || 0;
                                }

                                productBatch.batches.forEach(batch => {
                                  if (batch.batch_code !== selectedBatchCode) {
                                    totalAvailableStock += batch.stock || 0;
                                  }
                                });
                              }
                            }

                            // Show error if quantity exceeds total available stock
                            if (enteredQty > totalAvailableStock) {
                              showErrorToast({
                                title: "Insufficient Stock",
                                message: `Only ${parseFloat(totalAvailableStock.toFixed(2))} units available`
                              });


                              // Reset to available stock
                              if (isEditingMode) {
                                setEditQty(totalAvailableStock);
                              } else {
                                setTempQty(totalAvailableStock);
                              }
                              setTimeout(() => {
                                document.getElementById("temp_qty_input")?.focus();
                                document.getElementById("temp_qty_input")?.select();
                              }, 100);
                              return;
                            }
                          }
                        }}

                        onKeyDown={(event) => {
                          const currentUnit = isEditingMode ?
                            productsList.find(p => p.product_code === editingItem?.product_code)?.units :
                            productsList.find(p => p.code === selectedProductCode)?.units;

                          if (!isDecimalUnit(currentUnit) && (event.key === "." || event.key === ",")) {
                            event.preventDefault();
                            showErrorToast({
                              title: "Invalid Input",
                              message: "Decimal values are not allowed for PCS/NOS units!"
                            });
                            return;
                          }
                          if (event.key === "Enter") {
                            event.preventDefault();

                            // ✅ FIXED VALIDATION - Properly handle edit mode batch changes
                            const enteredQty = parseFloat(isEditingMode ? editQty : tempQty) || 0;
                            let totalAvailableStock = 0;

                            if (isEditingMode && editingItem) {
                              const productBatch = batches.find(p => p.product_code === editingItem.product_code);
                              if (productBatch?.batches) {
                                const targetBatchCode = selectedBatchCode || editingItem.batch_code;

                                // Find the selected batch first
                                const selectedBatch = productBatch.batches.find(b => b.batch_code === targetBatchCode);
                                if (selectedBatch) {
                                  // Add selected batch's TOTAL stock
                                  totalAvailableStock += selectedBatch.total_stock || 0;
                                }

                                // Add other batches' CURRENT stock
                                productBatch.batches.forEach(batch => {
                                  if (batch.batch_code !== targetBatchCode) {
                                    totalAvailableStock += batch.stock || 0;
                                  }
                                });
                              }
                            } else if (selectedBatchCode) {
                              const productToAdd = productsList.find(p => p.code === selectedProductCode);
                              const productBatch = batches.find(p => p.product_code === productToAdd?.product_code);
                              if (productBatch?.batches) {
                                const selectedBatch = productBatch.batches.find(b => b.batch_code === selectedBatchCode);
                                if (selectedBatch) {
                                  totalAvailableStock += selectedBatch.total_stock || 0;
                                }

                                productBatch.batches.forEach(batch => {
                                  if (batch.batch_code !== selectedBatchCode) {
                                    totalAvailableStock += batch.stock || 0;
                                  }
                                });
                              }
                            }

                            if (enteredQty > totalAvailableStock) {
                              showErrorToast({
                                title: "Insufficient Stock",
                                message: `Only ${parseFloat(totalAvailableStock.toFixed(2))} units available`
                              });
                              setTimeout(() => {
                                document.getElementById("temp_qty_input")?.focus();
                                document.getElementById("temp_qty_input")?.select();
                              }, 100);
                              return;
                            }

                            if (isEditingMode) {
                              document.getElementById("temp_discount_input")?.focus();
                            } else {
                              document.getElementById("temp_discount_input")?.focus();
                            }
                          }
                        }}
                      />
                      Qty
                    </Button>

                    {/* Discount Input */}
                    <Button
                      color={isProductSelected ? "orange" : "gray"}
                      variant={isProductSelected ? "filled" : "filled"}
                      size="xs"
                      px={3}>
                      <Flex align={"center"}>
                        <NumberInput
                          id="temp_discount_input"
                          type="number"
                          decimalSeparator="."
                          precision={2}
                          step={1}
                          onChange={(val) => isEditingMode ?
                            setEditingItem(prev => ({ ...prev, discountPercentage: val })) :
                            setTempDiscount(val)
                          }
                          value={isEditingMode ?
                            (editingItem?.discountPercentage || 0) :
                            (tempDiscount || "")
                          }
                          placeholder="Disc %"
                          min={0}
                          max={100}
                          size="xs"
                          w={60}
                          disabled={!selectedBatchCode && !isEditingMode}
                          onKeyDown={(event) => {
                            if (event.key === "Enter") {
                              event.preventDefault();
                              document.getElementById("temp_enter_button")?.focus();
                            }
                          }}
                        />
                      </Flex>
                      Dis
                    </Button>

                    {/* Enter Button */}
                    <Button
                      id="temp_enter_button"
                      color={isEditingMode ? "yellow" : "green"}
                      size="xs"
                      disabled={(!selectedBatchCode && !isEditingMode) || !tempQty}
                      onClick={isEditingMode ? handleEditEnter : handleAddProductEntry}
                    >
                      Enter
                    </Button>

                    {/* Clear Button - Clears only current selection */}
                    <Button
                      variant="filled"
                      color="red"
                      size="xs"
                      px={8}
                      py={2}
                      onClick={isEditingMode ? cancelEdit : handleClearSelection}
                      disabled={!selectedProductCode && !selectedBatchCode && !tempQty && !tempDiscount}
                      title={isEditingMode ? "Cancel editing and restore original" : "Clear current product selection"}
                      tabIndex={0}
                    >
                      <IconX size={20} />
                    </Button>
                  </Group>
                </Card>

                {/* RIGHT SECTION */}
                <Flex gap="md" align="stretch" style={{ justifyContent: "flex-end", maxWidth: "500px", height: "100%" }}>
                  {/* Coupon Card */}
                  <Card shadow="sm" radius="md" p="xs" withBorder
                    style={{
                      width: "220px",
                      height: "170px",
                      // display: "flex",
                      // flexDirection: "column",
                      // justifyContent: "space-between",
                    }}>
                    <Text fw={600} mb="xs" size="sm" color="orange.7">
                      <Group spacing="xs">
                        <IconTag size={14} />
                        Enter Coupon
                      </Group>
                    </Text>
                    <Box>
                      <TextInput
                        size="xs"
                        min={0}
                        label="Coupon Code"
                        placeholder="Enter Coupon Code (F3)"
                        styles={{
                          wrapper: {
                            transition: "all 150ms ease",
                            borderRadius: 6,

                            // 🟢 HOVER – OUTER SHADOW
                            "&:hover": {
                              boxShadow: "0 0 0 4px rgba(34,197,94,0.18)",
                            },

                            // 🟢 FOCUS – OUTER SHADOW
                            "&:focus-within": {
                              boxShadow: "0 0 0 4px rgba(34,197,94,0.25)",
                            },
                          },

                          input: {
                            transition: "all 150ms ease",

                            border:
                              activeShortcut === "coupon"
                                ? "2px solid #22c55e"
                                : "1px solid #ced4da",

                            backgroundColor: "#fff",

                            // 🟢 HOVER – INNER
                            "&:hover": {
                              backgroundColor: "rgba(34,197,94,0.06)",
                            },

                            // 🟢 FOCUS – INNER
                            "&:focus": {
                              border: "2px solid #22c55e",
                              backgroundColor: "rgba(34,197,94,0.12)",
                              boxShadow: "inset 0 0 0 1px rgba(34,197,94,0.2)",
                            },
                          },
                        }}

                        rightSection={
                          <Tooltip label="Clear Coupon">
                            <Flex style={{ alignItems: "center", justifyContent: "center" }}>
                              <IconX
                                style={{ width: 16 }}
                                onClick={() => {
                                  applyCoupon(false);
                                  setCouponCode({ coupon_code: "" });
                                }}
                              />
                            </Flex>
                          </Tooltip>
                        }
                        value={
                          couponCode?.coupon_code || ""
                        }
                        onChange={val => {
                          setCouponCode({ coupon_code: val.target.value });
                        }}
                        onKeyDown={(event) => {
                          if (event.key === "Enter") {
                            event.preventDefault();
                            applyCoupon(true);
                          }
                        }}
                      />

                      <Button
                        variant="outline"
                        size="xs"
                        w={"100%"}
                        mt={7}
                        onClick={() => {
                          if (couponCode?.coupon_code) {
                            applyCoupon(true);
                          } else {
                            showErrorToast({
                              title: "Error",
                              message: "Please enter a coupon code first!"
                            });
                          }
                        }}
                      >
                        Apply Coupon
                      </Button>
                      <Button
                        variant="subtle"
                        size="11px"
                        w={"100%"}
                        mt={0}
                        onClick={e => setCouponsModalOpened(true)}
                      >
                        Show All Coupons
                      </Button>
                    </Box>
                  </Card>

                  {/* Discount Card */}
                  <Card shadow="sm" radius="md" p="xs" withBorder
                    style={{
                      width: "220px",
                      height: "170px",
                      // display: "flex",
                      // flexDirection: "column",
                      // justifyContent: "space-between",
                    }}>
                    <Text fw={600} mb="xs" size="sm" color="red.7">
                      <Group spacing="xs">
                        <IconDiscount2 size={14} />
                        Net Discount
                      </Group>
                    </Text>
                    <Box>
                      <NumberInput
                        decimalSeparator="."
                        precision={2}
                        step={0.01}
                        type="number"
                        size="xs"
                        min={0}
                        label="Net Discount ( % )"
                        placeholder="Enter net discount % (F4)"
                        styles={{
                          wrapper: {
                            transition: "all 150ms ease",
                            borderRadius: 6,

                            // 🟢 HOVER – OUTER SHADOW
                            "&:hover": {
                              boxShadow: "0 0 0 4px rgba(34,197,94,0.18)",
                            },

                            // 🟢 FOCUS – OUTER SHADOW
                            "&:focus-within": {
                              boxShadow: "0 0 0 4px rgba(34,197,94,0.25)",
                            },
                          },

                          input: {
                            transition: "all 150ms ease",

                            border:
                              activeShortcut === "discount"
                                ? "2px solid #22c55e"
                                : "1px solid #ced4da",

                            backgroundColor: "#fff",

                            // 🟢 HOVER – INNER
                            "&:hover": {
                              backgroundColor: "rgba(34,197,94,0.06)",
                            },

                            // 🟢 FOCUS – INNER
                            "&:focus": {
                              border: "2px solid #22c55e",
                              backgroundColor: "rgba(34,197,94,0.12)",
                              boxShadow: "inset 0 0 0 1px rgba(34,197,94,0.2)",
                            },
                          },
                        }}
                        onChange={val => {
                          console.log(val);
                          setNetDiscount(val);
                        }}
                      />
                      <Button
                        variant="outline"
                        size="xs"
                        mt={8}
                        w={"100%"}
                        onClick={applyNetDiscount}
                      >
                        Apply Net Discount
                      </Button>
                      <Text size="9px" color="red" mt={4}>
                        Note: Applying Net discount will overwrite existing discount in the list.
                      </Text>
                    </Box>
                  </Card>
                </Flex>
              </Flex>

              {/* </Card> */}
            </Container></Box>
        </Box>
      )}
      {/* LEFT SIDE - Customer Card */}
      <Box
        style={{
          position: "absolute",
          right: "20px",
          top: "145px",
          width: "360px",
          height: "186px",
          zIndex: 10,
        }}
      >
        <Card shadow="sm" radius="md" p="xs" withBorder
          style={{
            width: "100%",
            height: "100%",
            overflow: "visible",
            boxShadow: "0 -2px 8px rgba(0, 0, 0, 0.18)",
            // zIndex: 10,
          }}>
          {/* <Group position="apart" align="center" > */}
          {/* <Text fw={600} size="md">
                      Invoice No
                    </Text> */}
          <Box mb="sm" style={{ position: "relative" }}>
            <div style={{
              position: "absolute",
              top: "-6px",
              left: "12px",
              // transform: "translateX(-50%)",
              fontSize: "14px",
              backgroundColor: "white",
              padding: "0 4px",
              zIndex: 2,
              color: "black",
              pointerEvents: "none",
              fontWeight: "bold",
              fontFamily: "inherit"
            }}>
              Invoice No
            </div>
            <TextInput
              size="sm"
              // label="Invoice ID"
              placeholder="Invoice number"
              value={invoicesId || ""}
              disabled
              styles={{
                input: {
                  backgroundColor: "#f8f9fa",
                  border: "1px solid #e9ecef",
                  fontWeight: "600",
                  textAlign: "right",
                  '&::placeholder': {
                    fontWeight: '700',
                    color: '#000000',
                    opacity: 1,
                  }
                },
                label: {
                  fontSize: "12px",
                  marginBottom: "4px",

                },
                root: {
                  marginTop: 0
                }
              }}
            />
          </Box>

          <Box mb="sm" style={{ position: "relative" }}>
            <div style={{
              position: "absolute",
              top: "-6px",
              left: "12px",
              // transform: "translateX(-50%)",
              fontSize: "13px",
              backgroundColor: "white",
              padding: "0 4px",
              zIndex: 2,
              color: "black",
              pointerEvents: "none",
              fontWeight: "bold",
              fontFamily: "inherit"
            }}>
              Invoice Date
            </div>
            <DatePickerInput
              placeholder="Select Invoice date"
              label=""
              size="sm"
              styles={{
                input: {
                  backgroundColor: "#f8f9fa",
                  border: "1px solid #e9ecef",
                  textAlign: "right",
                  '&::placeholder': {
                    fontWeight: '700',
                    color: '#000000',
                    opacity: 1,
                  }
                },
                root: {
                  marginTop: 0
                }
              }}
              data={[]}
              disabled
              {...form.getInputProps("date")}
            ></DatePickerInput>
          </Box>


          <CustomerSelection
            reference={customer_ref}
            inputRef={customerInputRef}
            id={customerId}
            disableAutoSelectCash={!!originalInvoiceNo}
            autoFocus={!location.pathname.includes("edit")}
            onChange={handleCustomerSelection}
            error={mobileNumberErrorMessage}
            setError={setMobileNumberErrorMessage}
            setCustomers={setCustomers}
            withinPortal
            dropdownPosition="bottom"
            styles={{ dropdown: { zIndex: 9999 } }}
          />
          {/* Yearly Coupon Status Badge - ADD THIS */}
          {customerId && customerYearlyCouponStatus && (
            <Badge
              color={customerQualifiesForYearlyCoupon ? "black" : "yellow"}
              variant="light"
              size="sm"
              ml={12}
              mt={10}
              style={{
                position: "absolute",
                bottom: "0px",
                right: "5px",
                cursor: 'default'
              }}
            >
              {customerQualifiesForYearlyCoupon
                ? `🏆 Eligible: ${yearlyCouponCode}`
                : `📊 ${customerYearlyCouponStatus.month_count || 0}/11 months`
              }
              {customerYearlyCouponStatus.cutt_off_amount && (
                <Text span size="xs" ml={5}>
                  (Min: ₹{customerYearlyCouponStatus.cutt_off_amount})
                </Text>
              )}
            </Badge>
          )}
        </Card>
      </Box>

      {/* ✅ Main Content (fills between header & footer) */}
      <Box
        style={{
          display: "flex",
          position: "fixed",
          top: "325px", // Below header
          bottom: "30px", // Above footer
          left: 0,
          right: 0,
          overflow: "hidden",
          padding: "10px",
          background: "#f8f9fa"
        }}
      >
        <Container fluid
          style={{
            height: "100%",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
            width: "100%",
            padding: 0,
            margin: 0
          }}>
          <Grid gutter="lg" style={{ flex: 1, overflow: "hidden", margin: 0, width: "100%" }}>

            {/* Left Panel - Products List */}
            <Col span={isMobileScreen ? 12 : 9} style={{ display: "flex", flexDirection: "column", height: "100%", paddingRight: "10px" }}>
              <Card shadow="sm" radius="md" p="md" withBorder
                style={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  height: "100%",
                  overflow: "hidden",
                  margin: 0,

                }}>
                {/* <Text fw={600} mb="md" >Invoice Items List</Text> */}

                {/* ✅ Internal Scroll Only */}
                <Box
                  style={{
                    flex: 1,
                    overflowY: "auto",       // scroll only inside
                    overflowX: "hidden",
                    height: "100%",
                    paddingRight: "4px",
                  }}
                >
                  <Table
                    key={invoiceItemsList}
                    withColumnBorders
                    withBorder
                    striped
                    highlightOnHover
                    fontSize="sm"
                    verticalSpacing={"xs"}
                    horizontalSpacing={"sm"}
                    tabIndex={0}
                    onFocus={() => setIsListFocused(true)}
                    onBlur={() => setIsListFocused(false)}
                    sx={theme => ({
                      background: "white",
                      borderRadius: 2,

                      // ========= Heading Styling (Density Reduce) =========
                      "thead tr": {
                        background: theme.colors.brand[1],
                        height: "32px !important",      // reduced height
                      },

                      "thead th": {
                        padding: "4px 6px !important",  // compact padding
                        fontSize: "13px",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                        textAlign: "center",
                        verticalAlign: "middle",
                      },

                      // ========= Body Row Density (little compact) =========
                      "tbody td": {
                        padding: "4px 6px !important",  // reduces row height a bit
                        fontSize: "14px",
                        verticalAlign: "middle",
                      },

                      // ========= Hover Style (keep your existing logic) =========
                      "tbody tr": {
                        transition: "all 0.2s ease",
                        cursor: "pointer",
                        "&:hover": {
                          backgroundColor: theme.colors.red[0] + "!important",
                        }
                      },

                      "&:focus": { outline: "none" }
                    })}

                  >
                    <thead>
                      <tr>
                        <th style={{ fontSize: "13px", whiteSpace: "nowrap" }}>S.No</th>
                        <th style={{ fontSize: "13px", whiteSpace: "nowrap" }}>Product</th>
                        <th style={{ fontSize: "13px", whiteSpace: "nowrap" }}>Batch</th>
                        <th style={{ fontSize: "13px", whiteSpace: "nowrap" }}>BB</th>
                        <th style={{ fontSize: "13px", whiteSpace: "nowrap" }}>Avl.Stock</th>
                        <th style={{ fontSize: "13px", whiteSpace: "nowrap" }}>MRP ₹ </th>
                        {/* <th>Basic Amount ₹ </th> */}
                        <th style={{ fontSize: "13px", whiteSpace: "nowrap" }}>Rate ₹ </th>
                        <th style={{ fontSize: "13px", whiteSpace: "nowrap" }}>Qty Pcs/Kg</th>
                        <th style={{ fontSize: "13px", whiteSpace: "nowrap" }}>Disc %</th>
                        <th style={{ fontSize: "13px", whiteSpace: "nowrap" }}>Disc. Amt ₹</th>
                        <th style={{ fontSize: "13px", whiteSpace: "nowrap" }}>Total ₹</th>
                        {/* <th>Edit</th> */}
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {invoiceItemsList.map((e, index) => {
                        if (!e.deleted) {
                          const uniqueId = `${e.product_code}_${e.batch_code}`;
                          const isEditingThisItem = editingItem?.uniqueId === uniqueId && !(e.qty < 0 || e.isReturnedItem);
                          const isSelected = selectedRow === uniqueId;
                          return (
                            <tr
                              key={uniqueId}
                              style={{
                                fontWeight: '500',
                                backgroundColor: isEditingThisItem ? '#fff3cd' :
                                  isSelected ? '#e3f2fd' : 'transparent',
                                cursor: 'pointer',
                                borderLeft: isSelected ? '4px solid #228be6' : 'none',
                                // Enhanced focus for keyboard navigation
                                outline: isSelected && isListFocused ? '2px solid #fd7e14' : 'none',
                                outlineOffset: '-2px'
                              }}
                              onClick={() => handleRowClick(uniqueId, e)}
                            >
                              <td style={{ width: "5%" }}>{index + 1}</td>

                              <td style={{ width: "200px" }}>
                                {isEditingThisItem && editStep === 'batch' ? (
                                  <TextInput
                                    value={editProductName}
                                    readOnly
                                    size="xs"
                                    styles={{
                                      input: {
                                        backgroundColor: '#f8f9fa',
                                        fontWeight: 'bold'
                                      }
                                    }}
                                  />
                                ) : (
                                  e.product_name
                                )}
                              </td>

                              <td style={{ maxWidth: 140 }}>
                                <Badge
                                  sx={{
                                    color: "gray",
                                    borderColor: "lightgray",
                                    cursor: "pointer",
                                  }}
                                  variant={"outline"}
                                  mb={5}
                                  onClick={() => {
                                    e.stopPropagation();
                                    setCurrentBatch(e.selected_batch);
                                    updateModalBatches(e.product_code, e.entered_qty);
                                    setProductSelectionModal(true);
                                  }}
                                >
                                  {e.batch_code}
                                </Badge>
                              </td>

                              <td> {getExpiryDayLeft(e.selected_batch.expiry_date)}</td>

                              <td width={70} style={{ textAlign: 'right' }}>{e?.total_avl_stock?.toFixed(3)}</td>

                              <td width={70} style={{ textAlign: 'right' }}> {e?.selected_batch?.mrp?.toFixed(2)}</td>

                              {/* <td style={{textAlign: 'right'}}>{+e?.basic_amount?.toFixed(2)}</td> */}

                              <td style={{ textAlign: 'right' }}>  {e?.selected_batch?.price.toFixed(2)}</td>

                              <td width={70} style={{ textAlign: "center" }}>
                                {isEditingThisItem && (editStep === 'qty' || editStep === 'disc') ? (
                                  <NumberInput
                                    id={`qty_input_${uniqueId}`}
                                    decimalSeparator="."
                                    // precision={3} // Allows values like 0.500
                                    // step={0.001} // Enables small decimal increments
                                    type="number"
                                    allowDecimal={isDecimalUnit(e.selected_unit)}

                                    precision={isDecimalUnit(e.selected_unit) ? 3 : 0}

                                    step={isDecimalUnit(e.selected_unit) ? 0.01 : 1}

                                    value={e.entered_qty}
                                    defaultValue={e.entered_qty}
                                    // max={e.selected_batch.total_stock}
                                    onBlur={val => {
                                      let inputQty = parseFloat(val.target.value) || 0;
                                      if (isDecimalUnit(e.selected_unit)) {
                                        inputQty = parseFloat(inputQty.toFixed(3));
                                      }
                                      updateQty(e.batch_code, inputQty, e.code);
                                      updateTotal();
                                      // }
                                    }}
                                    // min={0}
                                    size="xs"
                                    w={80}
                                    ref={element => {
                                      if (selectValue === e.code && focus) {
                                        element?.focus();
                                        element?.select();
                                        setFocus(false);
                                      }
                                      if (
                                        location.pathname.includes("edit") &&
                                        index === invoiceItemsList.length - 1 &&
                                        focusSearch
                                      ) {
                                        setSelectValue(e.code);
                                        setFocus(true);
                                        setfocusSearch(false);
                                      }
                                    }}
                                    onKeyDown={(event) => {


                                      if (!isDecimalUnit(e.selected_unit) && (event.key === "." || event.key === ",")) {
                                        event.preventDefault();
                                        showErrorToast({
                                          title: "Invalid Input",
                                          message: "Decimal values are not allowed for PCS/NOS units!"
                                        });
                                        return;
                                      }
                                      if (event.key === "Enter") {
                                        event.preventDefault(); // Prevents default behavior
                                        event.target.blur(); // Triggers onBlur manually
                                        setTimeout(() => {
                                          qty_ref?.current?.focus(); // Move focus to qty_ref after blur
                                        }, 10);
                                      }
                                      // if (event.key === "F4" || event.key === "F5") {
                                      if (event.key === "F5" && event.altKey) {
                                        event.preventDefault();
                                        event.target.blur();
                                      }
                                      if (event.key === "F6") {
                                        event.preventDefault();
                                        event.target.blur();
                                      }
                                    }}
                                    onChange={(value) => {
                                      if (!isDecimalUnit(e.selected_unit) && value && value.toString().includes('.')) {
                                        // Remove decimal part for non-decimal units
                                        const wholeNumber = Math.floor(value);
                                        setInvoiceItemsList(
                                          produce(draft => {
                                            const item = draft.find(item => item.code === e.code);
                                            if (item) {
                                              item.entered_qty = wholeNumber;
                                              item.qty = wholeNumber;
                                            }
                                          })
                                        );
                                        showErrorToast({
                                          title: "Invalid Input",
                                          message: "Decimal values are not allowed for PCS/NOS units!"
                                        });
                                        //       } else if (isDecimalUnit(e.selected_unit) && value) {
                                        // // ✅ FIX: Round to 3 decimal places while typing for KG units
                                        // const roundedValue = parseFloat(value.toFixed(3));
                                        // setInvoiceItemsList(
                                        //   produce(draft => {
                                        //     const item = draft.find(item => item.code === e.code);
                                        //     if (item) {
                                        //       item.entered_qty = roundedValue;
                                        //       item.qty = roundedValue;
                                        //     }
                                        //   })
                                        // );
                                      }
                                    }}
                                  />
                                ) : (
                                  <Text size="sm" fw={600}>
                                    {isDecimalUnit(e.selected_unit) ?
                                      (parseFloat(e.qty || 0).toFixed(3)) : // ✅ FIXED: toFixed(3) for KG units
                                      (e.qty || 0)
                                    }
                                  </Text>
                                )}
                              </td>
                              <td style={{ textAlign: "center" }}>
                                {isEditingThisItem && editStep === 'disc' ? (
                                  <NumberInput
                                    id={`edit_discount_${e.batch_code}`}
                                    value={editDiscount}
                                    onChange={setEditDiscount}
                                    decimalSeparator="."
                                    precision={2}
                                    step={0.01}
                                    min={0}
                                    max={100}
                                    size="xs"
                                    styles={{
                                      input: {
                                        fontWeight: 'bold',
                                        textAlign: 'center'
                                      }
                                    }}
                                    onKeyDown={(event) => {
                                      if (event.key === "Enter") {
                                        event.preventDefault();
                                        handleEditEnter();
                                      }
                                    }}
                                  />
                                ) : (
                                  <Text size="sm" color={e.discountPercentage > 0 ? "red" : "dimmed"}>
                                    {e.discountPercentage > 0 ? `${e.discountPercentage}%` : "0%"}
                                  </Text>
                                )}
                              </td>

                              <td width={70} style={{ textAlign: 'right' }}>
                                <Text size={"sm"} ml={10}>
                                  {e.discount ? Number(e.discount).toFixed(2) : '0.00'}
                                </Text>
                              </td>

                              <td style={{ textAlign: 'right' }}> {Number(e.total).toFixed(2)}</td>
                              {/* <td style={{ textAlign: "center" }}>
                  <ActionIcon
                    color="orange"
                    size="sm"
                    onClick={() => handleEditItem(e)}
                    disabled={isEditingMode}
                  >
                    <IconEdit size={20} />
                  </ActionIcon>
                </td> */}

                              <td align="center">
                                <ActionIcon
                                  color="red"
                                  onClick={(event) => {
                                    event.stopPropagation(); // Prevent row selection when deleting
                                    deleteInvoiceItem(uniqueId);
                                  }}
                                  disabled={isEditingMode}
                                >
                                  <IconSquareRoundedMinus
                                    style={{
                                      width: 20,
                                      cursor: "pointer",
                                    }}
                                  />
                                </ActionIcon>
                              </td>
                            </tr>
                          );
                        }
                      })}
                    </tbody>
                  </Table>
                </Box>

                {/* Empty List Alert */}
                {invoiceItemsList.length === 0 && (
                  <Alert
                    mt={20}
                    icon={<IconAlertCircle size="1rem" />}
                    title="Invoice list is empty."
                  >
                    Click on search box to search invoice item and select it to add to the invoice.
                  </Alert>
                )}

              </Card>
            </Col>




            {/* Right Panel - Invoice Summary */}
            <Col span={isMobileScreen ? 12 : 3} style={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
            }}>
              {/* <Stack spacing="xs" style={{
                    flex: 1,
                    overflowY: "auto",
                    paddingBottom: "10px",
                  }}> */}
              {/* Summary Card */}
              <Card style={{ backgroundColor: "#e9edeaff", height: "45px" }}>
                <Text fw={800} mb="xs" size="sm" color="green.7" align="center">
                  <Group spacing="xs">
                    <IconFileInvoice size={14} />
                    Invoice Summary
                  </Group>
                </Text>
              </Card>
              <Card style={{
                background: "white",
                padding: "10px 14px",
                borderRadius: "6px",
                marginBottom: "10px",
                border: "1px solid #cce3d5",
                height: "250px",
              }}>
                <Table withColumnBorders fontSize="sm" cellPadding={2}>
                  <tbody>
                    <tr>
                      <td style={{ padding: '4px' }}>Subtotal</td>
                      <td style={{ padding: '4px', textAlign: 'right' }}>₹ {(parseFloat(getTotal("subtotal")) || 0).toFixed(2)}</td>
                    </tr>
                    <tr>
                      <td style={{ padding: '4px' }}>Tax Total</td>
                      <td style={{ padding: '4px', textAlign: 'right' }}>₹ {(parseFloat(getTotal("tax")) || 0).toFixed(2)}</td>
                    </tr>
                    <tr>
                      <td style={{ padding: '4px' }}>Total Discount</td>
                      <td style={{ padding: '4px', textAlign: 'right' }}>₹ {(parseFloat(getTotal("discount")) || 0).toFixed(2)}</td>
                    </tr>
                    <tr>
                      <td style={{ padding: '4px' }}>Packing Charge</td>
                      <td style={{ padding: '4px', textAlign: 'right' }}>₹ {(parseFloat(getTotal("packing_charge")) || 0).toFixed(2)}</td>
                    </tr>
                    <tr>
                      <td style={{ padding: '4px' }}>Coupon</td>
                      <td style={{ padding: '4px', textAlign: 'right' }}>₹ {(parseFloat(getTotal("coupon")) || 0).toFixed(2)}</td>
                    </tr>

                    <tr>
                      <td style={{ padding: '4px' }}>Round Off</td>
                      <td style={{ padding: '4px', textAlign: 'right' }}>
                        {(() => {
                          const amount = parseFloat(getTotal("amount")) || 0;
                          const rounded = Math.sign(amount) * Math.round(Math.abs(amount));
                          const diff = rounded - amount;
                          return diff === 0
                            ? "₹ 0.00"
                            : `₹ ${(diff > 0 ? "+" : "") + diff.toFixed(2)}`;
                        })()}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ padding: '4px' }}><strong>Net Total</strong></td>
                      <td style={{ padding: '4px', textAlign: 'right' }}>
                        <strong>
                          ₹ {(Math.sign(parseFloat(getTotal("amount")) || 0) * Math.round(Math.abs(parseFloat(getTotal("amount")) || 0))).toFixed(2)}
                        </strong>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Card>

              {/* Action Button */}
              {/* <Card > */}
              <Button
                color="green"
                size="sm"
                fullWidth
                onClick={async () => {
                  // ✅ Validation: Block if total is 0 or negative
                  const currentTotalAmount = parseFloat(getTotal("amount")) || 0;

                  if (currentTotalAmount <= 0) {
                    showErrorToast({
                      title: "Invalid Total",
                      message: "Invoice total must be greater than 0 to proceed with Print & Save."
                    });
                    return;
                  }

                  setPayAndPrintBill(true);
                  setTimeout(async () => {
                    window.runStockRef = false;
                    saveInvoice()
                    await syncBatchStockToDB();
                  }, 100);
                }}
                loading={submitInvoice.isLoading}
              >
                {isInvoiceEditMode ? "Print & Save Invoice (alt+F5)" : "Print & Save Invoice (alt+F5)"}
              </Button>
              {/* </Card> */}
              {/* </Stack> */}

            </Col>
          </Grid>
        </Container>
      </Box>

      {/* ✅ Sticky Footer Bar */}
      <Box style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        width: "100%",
        background: "#fff",
        borderTop: "1px solid #ddd",
        zIndex: 20,
        padding: "10px 24px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "50px",
        fontSize: "18px",
        fontWeight: 600,
        height: "45px"
      }}>
        <Breadcrumbs separator="" sx={{ fontSize: 20, marginLeft: "150px" }}>
          Total Item: <Text span fw={600} sx={{ fontSize: 20 }}>{totalItems}</Text>
          Total Quantity: <Text span fw={600} sx={{ fontSize: 20 }}> {totalPcs !== 0 ? `${totalPcs} Pcs` : ""} {(totalPcs !== 0 && totalKgs !== 0) ? ' / ' : ''} {totalKgs !== 0 ? `${totalKgs.toFixed(3)} Kgs` : ""}</Text>
          Total Amount: <Text span fw={600} sx={{ fontSize: 20 }}>₹{(parseFloat(getTotal("amount")) || 0).toFixed(2)}</Text>
        </Breadcrumbs>
        {!isInvoiceEditMode && (
          <Button
            w={"355px"}
            color="green"
            fw={800}
            size="sm"
            sx={{
              borderRadius: "4px",
              height: "36px",
              marginRight: "0px",
              fontSize: "14px",
            }}
            onClick={() => {
              // ✅ Validation: Block if total is 0 or negative
              const currentTotalAmount = parseFloat(getTotal("amount")) || 0;

              if (currentTotalAmount <= 0) {
                showErrorToast({
                  title: "Invalid Total",
                  message: "Invoice total must be greater than 0 to proceed."
                });
                return;
              }

              setPayAndPrintBill(false);
              setIsF6Mode(true); // Set F6 mode
              setTimeout(() => {
                window.runStockRef = true;
                saveInvoice(null, true);
                // Reset after a delay
                setTimeout(() => setIsF6Mode(false), 1000);
              }, 100);
            }}
            loading={submitInvoice.isLoading}
          >
            Save Invoice (F6)
          </Button>
        )}
      </Box>


      {/* ENDS :: Main content */}

      {/* STARTS : Product Selection Modal */}
      <Modal
        opened={productSelectionModal}
        onClose={() => {
          setProductSelectionModal(false);
        }}
        title={
          <Box px={10}>
            <Text fw={"600"}>Select Batch</Text>
            {modalProductLabel && (
              <Text size="sm" color="dimmed">
                Product: {modalProductLabel}
              </Text>
            )}
          </Box>
        }
        size={"850px"}
        centered
      >
        <Box pl={10}>
          <Divider />
        </Box>
        <Box px={10} mb={10}>
          <Box mt={20}>
            <Table
              withColumnBorders
              highlightOnHover
              withBorder
              verticalSpacing={"xs"}
              horizontalSpacing={"xs"}
              className="normal-table"
              ref={batchTable}
            >
              <thead>
                <tr>
                  <th> Batch No. </th>
                  <th> Exp. Date </th>
                  <th> No Of Days To Expire </th>
                  {/* <th> Discount Price </th> */}
                  <th> Available Stock</th>
                  <th> Total Stock</th>
                  <th> Selling Price</th>
                  <th> MRP</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {modalBatches.map(e => {
                  // Calculate available stock using the helper function
                  const availableStock = getAvailableStockForBatch(e.product_code, e.batch_code);
                  const isZeroStock = availableStock === 0;
                  const isAlreadyInInvoice = invoiceItemsList.some(
                    item => item.batch_code === e.batch_code && item.product_code === e.product_code
                  );
                  const isSelectedBatch = selectedBatchCode === e.batch_code;
                  const isCurrentEditingBatch =
                    isEditingMode &&
                    editingItem?.product_code === e.product_code &&
                    editingItem?.batch_code === e.batch_code;
                  return (
                    <tr
                      key={e.batch_code}
                      tabIndex={0}
                      style={
                        !isEditingMode && (isAlreadyInInvoice || (isZeroStock && !isEditInvoiceMode))
                          ? {
                            background: "repeating-linear-gradient( 45deg, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1) 10px, rgba(0, 0, 0, 0.2) 10px, rgba(0, 0, 0, 0.2) 20px)",
                            opacity: ".4",
                          }
                          : isSelectedBatch || isCurrentEditingBatch
                            ? {
                              backgroundColor: "#e7f5ff",
                              boxShadow: "inset 0 0 0 1px #74c0fc",
                            }
                            : isZeroStock && isEditInvoiceMode
                              ? {
                                backgroundColor: "#fff8e1", // Light yellow background for zero-stock in edit mode
                                color: "#666",
                              }
                              : {}
                      }
                    >
                      <td>{e.batch_code}
                        {isZeroStock && isEditInvoiceMode && (
                          <Badge size="xs" color="red" ml={5}>
                            Zero Stock
                          </Badge>
                        )}
                      </td>
                      <td width={120}> {e.expiry_date} </td>
                      <td> {getExpiryDayLeft(e.expiry_date)} </td>
                      <td> {Number(e.stock).toFixed(3)} </td>
                      <td> {Number(e.total_stock).toFixed(3)} </td>
                      <td> {e.price} </td>
                      <td> {e.mrp} </td>
                      <td>
                        <Button
                          onClick={() => {
                            if (isEditingMode) {
                              handleBatchSelectInEdit(e);
                            } else {
                              // For new product selection
                              handleBatchSelect(e);
                            }
                            setProductSelectionModal(false);
                          }}
                          size="xs"
                          disabled={!isEditingMode && (isAlreadyInInvoice)}
                          color={
                            (isSelectedBatch || isCurrentEditingBatch) ? "green" : "blue"
                          }

                        >
                          {(isSelectedBatch || isCurrentEditingBatch) ? "Selected" : "Select"}
                        </Button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </Box>
        </Box>
      </Modal>
      {/* ENDS : Product Selection Modal */}

      {paymentReceiptFormVisible && (
        <AddPaymentReceipt
          opened={paymentReceiptFormVisible}
          fromInvoice={true}
          onClose={() => {
            setPaymentReceiptFormVisible(false);
            setPayAndPrintBill(false);
            printInvoice(invoicesData);
          }}
          defaultData={paymentReceiptData}
          invoiceId={paymentReceiptData?.invoice}
        />
      )}

      <CouponsModal
        modalOpened={couponsModalOpened}
        setModalOpened={setCouponsModalOpened}
        setCouponCode={setCouponCode}
        setCouponApplied={setCouponApplied}
        selectedReferralCoupon={selectedReferralCoupon}
        setSelectedReferralCoupon={setSelectedReferralCoupon}
        customerId={customerId}
        customerName={customers.find(c => c.id === customerId)?.name || customers.find(c => c.id === customerId)?.username || "Customer"}
        customerYearlyCouponStatus={customerYearlyCouponStatus}
        yearlyCouponCode={yearlyCouponCode}
        customerQualifiesForYearlyCoupon={customerQualifiesForYearlyCoupon}
      />
    </>
  );
}
